var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLogoAccretech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 287.981,
    height: 67.302,
    viewBox: "0 0 287.981 67.302",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_accretech",
    transform: "translate(0.004 -0.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    transform: "translate(-0.004 0.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    d: "M22.3,48.791h8.193v-19.9H41.025v19.9h8.193V.8H41.025V18.357H30.493V.8H22.3Z",
    transform: "translate(238.764 8.271)",
    fill: "#14429a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    d: "M45.55,48.791V39.426C44.379,40.6,42.038,40.6,40.867,40.6c-5.852,0-10.534-5.852-10.534-15.216S35.014,10.165,39.7,10.165c1.171,0,3.512,0,4.681,1.171V1.971C43.21.8,40.869.8,38.525.8,27.993.8,19.8,10.164,19.8,26.55S30.334,49.96,40.869,49.96C43.21,49.96,44.379,49.96,45.55,48.791Z",
    transform: "translate(212.002 8.271)",
    fill: "#14429a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    d: "M18.3,48.791H37.025V39.426H26.493V28.891h9.364V19.525H26.493V10.164H37.025V.8H18.3Z",
    transform: "translate(195.945 8.271)",
    fill: "#14429a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    "data-name": "Path 1444",
    d: "M23.222,48.791h9.364V10.164h5.852V.8H16.2v9.364h7.022Z",
    transform: "translate(173.464 8.271)",
    fill: "#14429a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1445",
    "data-name": "Path 1445",
    d: "M14.6,48.791H33.325V39.426H22.793V28.891h9.364V19.525H22.793V10.164H33.325V.8H14.6Z",
    transform: "translate(156.336 8.271)",
    fill: "#14429a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M12.4,49.86h8.193V29.966L27.616,49.86h9.364L28.786,27.621c4.683-1.171,7.022-5.852,7.022-12.876Q35.81.7,21.764.7H12.4Zm9.364-26.921V10.064h1.171c3.512,0,5.852,2.341,5.852,7.022s-2.341,5.852-7.022,5.852Z",
    transform: "translate(132.786 7.2)",
    fill: "#14429a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    d: "M35.75,48.791V39.426C34.579,40.6,32.238,40.6,31.067,40.6c-5.852,0-10.534-5.852-10.534-15.216S25.216,10.165,29.9,10.165c1.171,0,3.512,0,4.681,1.171V1.971C33.41.8,31.069.8,28.725.8,18.193.8,10,10.164,10,26.55s9.364,23.41,21.069,23.41a8.848,8.848,0,0,0,4.681-1.169Z",
    transform: "translate(107.095 8.271)",
    fill: "#14429a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M31.41,48.791V39.426c-1.171,0-3.512,1.171-4.683,1.171-5.852,0-10.534-5.852-10.534-15.216s4.683-15.216,9.364-15.216c1.171,0,3.512,0,4.683,1.171V1.971C30.239.8,27.9.8,25.557.8,15.022.8,8,10.164,8,25.379s7.022,24.579,18.725,24.579C27.9,49.96,30.239,49.96,31.41,48.791Z",
    transform: "translate(85.685 8.271)",
    fill: "#14429a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M5.6,48.791h8.193L14.964,40.6h9.361L25.5,48.791h8.193L24.325.8H14.964ZM17.305,33.575a143.416,143.416,0,0,0,2.341-22.241c1.171,7.022,2.341,15.216,3.512,22.239Z",
    transform: "translate(59.994 8.271)",
    fill: "#14429a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    d: "M2.3,2.9,16.346,34.5a7.462,7.462,0,0,0,7.022,0c2.341-1.171,3.512-4.683,2.341-5.852Z",
    transform: "translate(24.668 30.75)",
    fill: "#5d71b6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M2.3,3,16.346,34.6c2.341,1.171,4.683,1.171,5.852,0,2.341-1.171,3.512-3.512,2.341-5.852Z",
    transform: "translate(24.668 31.821)",
    fill: "#6576b9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    d: "M2.3,3c4.683,10.534,9.364,21.069,14.046,30.433,2.341,1.171,4.683,1.171,5.852,0,2.341-1.171,3.512-3.512,2.341-4.683Z",
    transform: "translate(24.668 31.821)",
    fill: "#6c7ab9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    d: "M2.3,3c4.683,10.534,9.364,21.069,14.046,30.433a5.316,5.316,0,0,0,5.852,0c2.341-1.171,3.512-3.512,2.341-4.683Z",
    transform: "translate(24.668 31.821)",
    fill: "#717fbe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    d: "M2.4,3c4.683,10.534,9.364,19.9,14.046,30.433,1.171,1.171,3.512,1.171,5.852,0s3.512-3.512,2.341-4.683Z",
    transform: "translate(25.739 31.821)",
    fill: "#7684c1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    d: "M2.4,3c4.683,9.364,9.364,19.9,14.046,30.433,1.171,1.171,3.512,1.171,5.852,0a4.673,4.673,0,0,0,2.341-4.683Z",
    transform: "translate(25.739 31.821)",
    fill: "#7d8ac2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    d: "M2.4,3,16.446,32.266a3.56,3.56,0,0,0,4.683,0,8.877,8.877,0,0,0,2.341-4.683Z",
    transform: "translate(25.739 31.821)",
    fill: "#848fc7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    "data-name": "Path 1457",
    d: "M2.4,3.1,16.446,32.366a3.56,3.56,0,0,0,4.683,0,8.877,8.877,0,0,0,2.341-4.683Z",
    transform: "translate(25.739 32.891)",
    fill: "#8a95ca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    d: "M2.4,3.1,16.446,32.366a3.56,3.56,0,0,0,4.683,0,16.837,16.837,0,0,0,2.341-3.512Z",
    transform: "translate(25.739 32.891)",
    fill: "#9099cd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    d: "M2.4,3.1,16.446,31.191a3.56,3.56,0,0,0,4.683,0c1.171-1.171,2.341-2.341,2.341-3.512Z",
    transform: "translate(25.739 32.891)",
    fill: "#99a0d1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    d: "M2.4,3.1,16.446,31.191a3.56,3.56,0,0,0,4.683,0C22.3,30.021,23.47,28.85,22.3,27.679Z",
    transform: "translate(25.739 32.891)",
    fill: "#a2a8d4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    d: "M2.4,3.1,16.446,31.191a2.194,2.194,0,0,0,3.512,0c1.171-1.171,2.341-2.341,1.171-3.512Z",
    transform: "translate(25.739 32.891)",
    fill: "#a6aed8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    d: "M2.5,3.2,16.546,30.121a2.194,2.194,0,0,0,3.512,0c1.171-1.171,2.341-2.341,1.171-3.512C14.205,18.416,8.352,10.222,2.5,3.2Z",
    transform: "translate(26.809 33.962)",
    fill: "#afb6dc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M2.5,3.2,16.546,30.121a2.194,2.194,0,0,0,3.512,0c1.171-1.171,2.341-2.341,1.171-3.512C14.205,18.416,8.352,10.222,2.5,3.2Z",
    transform: "translate(26.809 33.962)",
    fill: "#b6bbdf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M2.5,3.2,16.546,30.121a2.194,2.194,0,0,0,3.512,0c0-1.171,1.171-2.341,1.171-3.512Z",
    transform: "translate(26.809 33.962)",
    fill: "#bdc3e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M2.5,3.2,16.546,30.121c1.171,1.171,2.341,1.171,2.341,0,1.171-1.171,2.341-2.341,1.171-3.512Z",
    transform: "translate(26.809 33.962)",
    fill: "#c7cbe7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M2.5,3.2,16.546,28.95c1.171,1.171,2.341,1.171,2.341,0,1.171,0,2.341-1.171,1.171-2.341Z",
    transform: "translate(26.809 33.962)",
    fill: "#d1d2ea",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M2.5,3.2,16.546,28.95h2.341c1.171,0,1.171-1.171,1.171-2.341Z",
    transform: "translate(26.809 33.962)",
    fill: "#d9daee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M2.5,3.2,16.546,28.95h2.341c1.171,0,1.171-1.171,1.171-2.341Z",
    transform: "translate(26.809 33.962)",
    fill: "#e0e0f1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M2.5,3.3,16.546,27.879h2.341c1.171,0,1.171-1.171,1.171-2.341Z",
    transform: "translate(26.809 35.033)",
    fill: "#e9ebf6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M2.5,3.3,16.546,27.879h1.171c2.341,0,2.341-1.171,2.341-1.171h0Z",
    transform: "translate(26.809 35.033)",
    fill: "#f1f2f9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M2.5,3.3,16.546,27.879h1.171l1.171-1.171Z",
    transform: "translate(26.809 35.033)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    d: "M52.343,4.254c3.512,5.852-4.683,21.069-18.725,31.6S4.353,51.073.841,44.05s4.683-21.069,18.725-31.6S48.831-2.769,52.343,4.254Z",
    transform: "translate(0.377 9.498)",
    fill: "#817b97",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    d: "M52.343,4.254c3.512,5.852-4.683,21.069-18.725,31.6S4.353,51.073.841,44.05s4.683-21.069,18.725-31.6S48.831-2.769,52.343,4.254Z",
    transform: "translate(0.377 9.498)",
    fill: "#817b97",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    d: "M52.343,4.254c3.512,7.022-4.683,21.069-18.725,31.6S4.353,51.073.841,44.05s4.683-21.069,18.725-31.6S48.831-2.769,52.343,4.254Z",
    transform: "translate(0.377 9.498)",
    fill: "#817e98",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    d: "M52.343,4.254c3.512,5.852-4.683,19.9-18.725,31.6S4.353,51.073.841,44.05s4.683-21.069,18.725-31.6S48.831-2.769,52.343,4.254Z",
    transform: "translate(0.377 9.498)",
    fill: "#817e98",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    d: "M52.343,4.495c3.512,5.852-4.683,19.9-18.725,31.6S4.353,50.142.841,44.291s4.683-19.9,18.728-31.6S48.831-2.528,52.343,4.495Z",
    transform: "translate(0.377 9.259)",
    fill: "#817e98",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    d: "M52.343,4.495c3.512,5.852-4.683,19.9-18.725,31.6S4.353,50.142.841,44.291s4.683-19.9,18.728-31.6S48.831-2.528,52.343,4.495Z",
    transform: "translate(0.377 9.259)",
    fill: "#817e99",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    d: "M52.343,4.495c3.512,5.852-4.683,19.9-18.725,31.6S4.353,50.142.841,44.291s4.683-19.9,18.728-31.6S48.831-2.528,52.343,4.495Z",
    transform: "translate(0.377 9.259)",
    fill: "#817e99",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M52.343,4.495c3.512,5.852-4.683,19.9-18.725,31.6S4.353,50.142.841,44.291s4.683-19.9,18.728-31.6S48.831-2.528,52.343,4.495Z",
    transform: "translate(0.377 9.259)",
    fill: "#817e99",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M52.708,4.021c3.512,5.852-4.683,19.9-18.725,31.6S5.9,49.669,1.214,43.817s4.683-19.9,18.728-31.6S49.2-1.833,52.708,4.021Z",
    transform: "translate(0.004 9.733)",
    fill: "#817e99",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M52.708,4.021c3.512,5.852-4.683,19.9-18.725,31.6S5.9,49.669,1.214,43.817s4.683-19.9,18.728-31.6S49.2-1.833,52.708,4.021Z",
    transform: "translate(0.004 9.733)",
    fill: "#817e99",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M52.708,4.021c3.512,5.852-4.683,19.9-18.725,31.6S5.9,49.669,1.214,43.817s4.683-19.9,18.728-31.6S49.2-1.833,52.708,4.021Z",
    transform: "translate(0.004 9.733)",
    fill: "#82809a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M52.708,4.021c3.512,5.852-4.683,19.9-18.725,31.6S5.9,49.669,1.214,43.817s4.683-19.9,18.728-31.6S49.2-1.833,52.708,4.021Z",
    transform: "translate(0.004 9.733)",
    fill: "#82819a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M52.708,4.021c3.512,5.852-4.683,19.9-18.725,31.6S5.9,49.669,1.214,43.817s4.683-19.9,18.728-31.6S49.2-1.833,52.708,4.021Z",
    transform: "translate(0.004 9.733)",
    fill: "#82819a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M52.708,4.021c3.517,5.852-4.676,19.9-18.725,30.431S5.9,49.669,1.214,43.817s4.683-19.9,18.728-31.6S49.2-1.833,52.708,4.021Z",
    transform: "translate(0.004 9.733)",
    fill: "#82819a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M52.708,3.531c3.512,5.852-4.683,19.9-18.725,30.433S5.9,49.18,1.214,43.328,5.9,23.43,19.941,12.9,49.2-2.322,52.708,3.531Z",
    transform: "translate(0.004 10.221)",
    fill: "#82819a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M52.708,3.531c3.512,5.852-4.683,19.9-18.725,30.433S5.9,49.18,1.214,43.328,5.9,23.43,19.941,12.9,48.033-2.322,52.708,3.531Z",
    transform: "translate(0.004 10.221)",
    fill: "#82819a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M51.269,3.531c3.512,5.852-4.683,19.9-18.725,30.433S4.453,49.18.941,43.328,5.624,23.43,19.666,12.9,46.591-2.322,51.269,3.531Z",
    transform: "translate(1.447 10.221)",
    fill: "#86839d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    d: "M51.269,3.531c3.512,5.852-4.683,19.9-18.725,30.433S4.453,49.18.941,43.328,5.624,23.43,19.666,12.9,46.591-2.322,51.269,3.531Z",
    transform: "translate(1.447 10.221)",
    fill: "#88839b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    d: "M51.269,3.531c3.512,5.852-4.683,19.9-17.557,30.433S4.453,49.18.941,43.328,5.624,23.43,19.666,12.9,46.591-2.322,51.269,3.531Z",
    transform: "translate(1.447 10.221)",
    fill: "#88839b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    d: "M51.348,3.531C54.86,9.385,46.667,23.43,33.8,33.964S4.529,49.18,1.019,43.328,4.529,23.43,18.575,12.9,46.667-2.322,51.348,3.531Z",
    transform: "translate(1.37 10.221)",
    fill: "#87869e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    d: "M51.348,3.531C54.86,9.385,46.667,23.43,33.8,33.964S4.529,49.18,1.019,43.328,4.529,23.43,18.575,12.9,46.667-2.322,51.348,3.531Z",
    transform: "translate(1.37 10.221)",
    fill: "#88869d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    d: "M50.179,3.531c3.512,5.852-4.683,19.9-17.557,30.433S4.529,49.18,1.019,43.328,4.529,23.43,18.575,12.9,46.667-2.322,50.179,3.531Z",
    transform: "translate(1.37 10.221)",
    fill: "#88859d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M50.179,3.531c3.512,5.852-4.683,19.9-17.557,30.433S4.529,49.18,1.019,43.328,4.529,23.43,18.575,12.9,46.667-2.322,50.179,3.531Z",
    transform: "translate(1.37 10.221)",
    fill: "#88869d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    d: "M50.179,3.531c3.512,5.852-4.683,19.9-17.557,30.433S4.529,49.18,1.019,43.328,4.529,23.43,18.575,12.9,46.667-2.322,50.179,3.531Z",
    transform: "translate(1.37 10.221)",
    fill: "#88869d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M50.179,3.532c3.512,5.852-4.683,19.9-17.557,30.433S4.529,49.18,1.019,42.158,4.531,23.433,18.575,12.892,46.667-2.321,50.179,3.532Z",
    transform: "translate(1.37 10.22)",
    fill: "#88869d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    d: "M50.179,3.532c3.512,5.852-4.683,19.9-17.557,30.433S4.529,49.18,1.019,42.158,4.531,23.433,18.575,12.892,46.667-2.321,50.179,3.532Z",
    transform: "translate(1.37 10.22)",
    fill: "#8c889e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    d: "M50.106,3.532c3.512,5.853-4.681,19.9-17.561,30.433S4.458,49.18.946,42.158,5.628,23.433,18.5,12.892,46.594-2.321,50.106,3.532Z",
    transform: "translate(1.443 10.22)",
    fill: "#8c889e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    d: "M50.106,3.532c3.512,5.853-4.681,19.9-17.561,30.433S4.458,49.18.946,42.158,5.628,23.433,18.5,12.892,46.594-2.321,50.106,3.532Z",
    transform: "translate(1.443 10.22)",
    fill: "#8e899e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M50.106,3.532c3.512,5.853-4.681,19.9-17.561,30.433S4.458,49.18.946,42.158,5.628,23.433,18.5,12.892,46.594-2.321,50.106,3.532Z",
    transform: "translate(1.443 10.22)",
    fill: "#8b889f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    d: "M50.106,4.354c3.512,5.853-4.681,19.9-17.561,30.433S4.458,47.663.946,41.809,5.628,23.085,18.5,12.543,46.594-2.668,50.106,4.354Z",
    transform: "translate(1.443 10.568)",
    fill: "#8b889f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    d: "M50.106,3.879c3.512,5.852-4.681,19.9-17.561,30.433S4.458,47.185.946,41.339,5.628,22.606,18.5,12.073,46.594-1.975,50.106,3.879Z",
    transform: "translate(1.443 11.045)",
    fill: "#8e899e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    d: "M50.106,3.879c3.512,5.852-3.512,19.9-17.561,30.433S4.458,47.185.946,41.339,5.628,22.606,18.5,12.073,46.594-1.975,50.106,3.879Z",
    transform: "translate(1.443 11.045)",
    fill: "#8e899e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    d: "M50.106,3.879C53.618,9.73,45.423,22.6,32.549,33.145S4.458,47.185.946,41.339,5.628,22.606,18.5,12.073,46.594-1.975,50.106,3.879Z",
    transform: "translate(1.443 11.045)",
    fill: "#8e899e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    d: "M50.106,3.879C53.618,9.73,45.423,22.6,32.549,33.145S4.458,47.185.946,41.339,5.628,22.606,18.5,12.073,46.594-1.975,50.106,3.879Z",
    transform: "translate(1.443 11.045)",
    fill: "#908b9f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    d: "M50.106,3.879C53.618,9.73,46.594,22.6,32.549,33.145S4.458,47.185.946,41.339,5.628,22.606,18.5,12.073,46.594-1.975,50.106,3.879Z",
    transform: "translate(1.443 11.045)",
    fill: "#908b9f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    d: "M50.106,3.879C53.618,9.73,45.423,22.6,32.549,33.145S4.458,47.185.946,41.339,5.628,22.606,18.5,12.073,46.594-1.975,50.106,3.879Z",
    transform: "translate(1.443 11.045)",
    fill: "#908b9f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    d: "M50.106,3.879C53.618,9.73,45.423,22.6,32.549,33.145S4.458,47.185.946,41.339,5.628,22.606,18.5,12.073,46.594-1.975,50.106,3.879Z",
    transform: "translate(1.443 11.045)",
    fill: "#8f8c9f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M50.48,3.879C53.992,9.73,45.8,22.6,32.923,33.145S6,47.185,1.32,41.339,6,22.606,18.877,12.073,46.968-1.975,50.48,3.879Z",
    transform: "translate(1.069 11.045)",
    fill: "#8f8c9f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    d: "M50.48,3.879C53.992,9.73,45.8,22.6,32.923,33.145S6,47.185,1.32,41.339,6,22.606,18.877,12.073,46.968-1.975,50.48,3.879Z",
    transform: "translate(1.069 11.045)",
    fill: "#8f8c9f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    d: "M50.48,3.879C53.992,9.73,45.8,22.6,32.923,33.145S6,47.185,1.32,41.339,6,22.606,18.877,12.073,46.968-1.975,50.48,3.879Z",
    transform: "translate(1.069 11.045)",
    fill: "#8f8c9f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1512",
    "data-name": "Path 1512",
    d: "M50.48,3.879C53.992,9.73,45.8,22.6,32.923,33.145S6,47.185,1.32,41.339,6,22.606,18.877,12.073,46.968-1.975,50.48,3.879Z",
    transform: "translate(1.069 11.045)",
    fill: "#8f8c9f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    d: "M50.48,3.879C53.992,9.73,45.8,22.6,32.923,33.145S6,47.185,1.32,41.339,6,22.606,18.877,12.073,46.968-1.975,50.48,3.879Z",
    transform: "translate(1.069 11.045)",
    fill: "#9391a3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    d: "M50.48,3.879C53.992,9.73,45.8,22.6,32.923,33.145S6,47.185,1.32,41.339,6,22.606,18.877,12.073,46.968-1.975,50.48,3.879Z",
    transform: "translate(1.069 11.045)",
    fill: "#9391a3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    d: "M50.48,3.879C53.992,9.73,45.8,22.6,32.923,33.145S6,47.185,1.32,41.339,6,22.606,18.877,12.073,46.968-1.975,50.48,3.879Z",
    transform: "translate(1.069 11.045)",
    fill: "#9391a3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1516",
    "data-name": "Path 1516",
    d: "M49.112,3.879C52.62,9.73,44.436,22.606,31.555,33.141S4.629,47.185,1.124,41.339s3.5-18.733,16.386-29.266S45.6-1.975,49.112,3.879Z",
    transform: "translate(2.436 11.045)",
    fill: "#9391a3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1517",
    "data-name": "Path 1517",
    d: "M49.112,3.879C52.62,9.73,44.436,22.606,31.555,33.141S4.629,47.185,1.124,41.339s3.5-18.733,16.386-29.266S45.6-1.975,49.112,3.879Z",
    transform: "translate(2.436 11.045)",
    fill: "#9690a3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    d: "M49.112,3.879C52.62,9.73,44.436,22.606,31.555,33.141S4.629,47.185,1.124,41.339s3.5-18.733,16.386-29.266S44.436-1.975,49.112,3.879Z",
    transform: "translate(2.436 11.045)",
    fill: "#9690a3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    d: "M47.937,3.879C52.619,9.73,44.425,22.6,31.551,33.145S4.629,47.185,1.119,41.339,4.629,22.606,18.675,12.073,44.425-1.975,47.937,3.879Z",
    transform: "translate(2.441 11.045)",
    fill: "#9592a3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    d: "M47.937,3.879C52.619,9.73,44.425,22.6,31.551,33.145S4.629,47.185,1.119,41.339,4.629,22.606,18.675,12.073,44.425-1.975,47.937,3.879Z",
    transform: "translate(2.441 11.045)",
    fill: "#9592a3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    d: "M47.937,3.879C52.619,9.73,44.425,22.6,31.551,33.145S4.629,47.185,1.119,41.339,4.629,22.606,18.675,12.073,44.425-1.975,47.937,3.879Z",
    transform: "translate(2.441 11.045)",
    fill: "#9592a3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    "data-name": "Path 1522",
    d: "M47.937,3.879C52.619,9.73,44.425,22.6,31.551,33.145S4.629,47.185,1.119,41.339,4.629,22.606,18.675,12.073,44.425-1.975,47.937,3.879Z",
    transform: "translate(2.441 11.045)",
    fill: "#9894a3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1523",
    "data-name": "Path 1523",
    d: "M47.937,3.879C52.619,9.73,44.425,22.6,31.551,33.145S4.629,47.185,1.119,41.339,4.629,22.606,18.675,12.073,44.425-1.975,47.937,3.879Z",
    transform: "translate(2.441 11.045)",
    fill: "#9894a3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    d: "M47.937,3.879C51.449,9.73,44.425,22.6,31.551,33.145S4.629,47.185,1.119,41.339,4.629,22.606,18.675,12.073,44.425-1.975,47.937,3.879Z",
    transform: "translate(2.441 11.045)",
    fill: "#9795a5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    d: "M47.937,3.879C51.449,9.73,44.425,22.6,31.551,33.145S4.629,46.015,1.119,41.339,4.629,22.606,18.675,12.073,44.425-1.975,47.937,3.879Z",
    transform: "translate(2.441 11.045)",
    fill: "#9795a5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    d: "M47.937,3.4c3.512,5.852-3.512,18.725-16.386,29.266S4.629,45.541,1.119,40.858,4.631,22.134,18.675,11.592,44.425-1.278,47.937,3.4Z",
    transform: "translate(2.441 11.519)",
    fill: "#9795a5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    d: "M47.937,3.4c3.512,5.852-3.512,18.725-16.386,29.266S4.629,45.54,1.119,39.687,4.629,22.13,18.675,11.6,44.425-1.279,47.937,3.4Z",
    transform: "translate(2.441 11.52)",
    fill: "#9795a5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    d: "M47.937,3.4c3.512,5.852-3.512,18.725-16.386,29.266S4.629,45.54,1.119,39.687,4.629,22.13,18.675,11.6,44.425-1.279,47.937,3.4Z",
    transform: "translate(2.441 11.52)",
    fill: "#9795a5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    d: "M47.937,3.4c3.512,5.852-3.512,18.725-16.386,29.266S4.629,45.54,1.119,39.687,4.629,22.13,18.675,11.6,44.425-1.279,47.937,3.4Z",
    transform: "translate(2.441 11.52)",
    fill: "#9c96a5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    d: "M47.937,3.4c3.512,5.852-3.512,18.725-16.386,29.266S4.629,45.54,1.119,39.687,4.629,22.13,18.675,11.6,44.425-1.279,47.937,3.4Z",
    transform: "translate(2.441 11.52)",
    fill: "#9c96a5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M47.864,4.268c3.5,4.681-3.511,17.557-16.386,28.091S4.558,45.234,1.046,39.382,5.728,21.825,18.6,11.29,44.354-1.585,47.864,4.268Z",
    transform: "translate(2.514 11.827)",
    fill: "#9795a5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M47.864,4.268c3.5,4.681-3.511,17.557-16.386,28.091S4.558,45.234,1.046,39.382,5.728,21.825,18.6,11.29,44.354-1.585,47.864,4.268Z",
    transform: "translate(2.514 11.827)",
    fill: "#9c96a4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    d: "M47.864,4.268c3.5,4.681-3.511,17.557-16.386,28.091S4.558,45.234,1.046,39.382,5.728,21.825,18.6,11.29,44.354-1.585,47.864,4.268Z",
    transform: "translate(2.514 11.827)",
    fill: "#9b9aa7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1534",
    "data-name": "Path 1534",
    d: "M47.864,4.268c3.5,4.681-3.511,17.557-16.386,28.091S4.558,45.234,1.046,39.382,5.728,21.825,18.6,11.29,44.354-1.585,47.864,4.268Z",
    transform: "translate(2.514 11.827)",
    fill: "#9b9aa6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1535",
    "data-name": "Path 1535",
    d: "M47.864,4.268c3.5,4.681-3.511,17.557-17.557,28.091S4.558,45.234,1.046,39.382,5.728,21.825,18.6,11.29,44.354-1.585,47.864,4.268Z",
    transform: "translate(2.514 11.827)",
    fill: "#9b9aa6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1536",
    "data-name": "Path 1536",
    d: "M47.864,4.268c3.5,5.852-3.511,17.557-16.386,28.091S4.558,45.234,1.046,39.382,5.728,21.825,18.6,11.29,44.354-1.585,47.864,4.268Z",
    transform: "translate(2.514 11.827)",
    fill: "#9b9aa6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1537",
    "data-name": "Path 1537",
    d: "M47.864,4.268c3.5,5.852-3.511,17.557-16.386,28.091S4.558,45.234,1.046,39.382,5.728,21.825,18.6,11.29,44.354-1.585,47.864,4.268Z",
    transform: "translate(2.514 11.827)",
    fill: "#9b9aa6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1538",
    "data-name": "Path 1538",
    d: "M47.864,4.268c3.5,5.852-3.511,17.557-16.386,28.091S4.558,45.234,1.046,39.382,5.728,21.825,18.6,11.29,44.354-1.585,47.864,4.268Z",
    transform: "translate(2.514 11.827)",
    fill: "#9b9ba8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1539",
    "data-name": "Path 1539",
    d: "M47.864,4.268c3.5,5.852-3.511,17.557-16.386,28.091S4.558,45.234,1.046,39.382,5.728,21.825,18.6,11.29,44.354-1.585,47.864,4.268Z",
    transform: "translate(2.514 11.827)",
    fill: "#9d9aa6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1540",
    "data-name": "Path 1540",
    d: "M47.864,4.268c3.5,5.852-3.511,17.557-16.386,28.091S4.558,45.234,1.046,39.382,5.728,21.825,18.6,11.29,44.354-1.585,47.864,4.268Z",
    transform: "translate(2.514 11.827)",
    fill: "#9b9ba6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1541",
    "data-name": "Path 1541",
    d: "M47.864,4.268c3.5,5.852-3.511,17.557-16.386,28.091S4.558,45.234,1.046,39.382,5.728,21.825,18.6,11.29,44.354-1.585,47.864,4.268Z",
    transform: "translate(2.514 11.827)",
    fill: "#9b9ba6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1542",
    "data-name": "Path 1542",
    d: "M46.51,4.268C50.022,10.12,43,21.825,30.124,32.359S3.2,45.234.862,39.382,4.374,21.825,17.248,11.29,43-1.585,46.51,4.268Z",
    transform: "translate(3.868 11.827)",
    fill: "#9d9ca6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1543",
    "data-name": "Path 1543",
    d: "M46.51,4.268C50.022,10.12,43,21.825,30.124,32.359S3.2,45.234.862,39.382,4.374,21.825,17.248,11.29,43-1.585,46.51,4.268Z",
    transform: "translate(3.868 11.827)",
    fill: "#9d9ca6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1544",
    "data-name": "Path 1544",
    d: "M46.872,4.268c3.512,5.852-3.512,17.557-16.386,28.091S4.729,45.234,1.224,39.382,4.729,21.825,17.61,11.29,43.36-1.585,46.872,4.268Z",
    transform: "translate(3.506 11.827)",
    fill: "#9f9ea7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1545",
    "data-name": "Path 1545",
    d: "M45.7,4.268c3.511,5.852-3.512,17.557-16.386,26.918S4.729,45.234,1.224,39.382,4.729,21.825,17.61,11.29,43.36-1.585,45.7,4.268Z",
    transform: "translate(3.506 11.827)",
    fill: "#9f9ea7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1546",
    "data-name": "Path 1546",
    d: "M45.7,4.268c3.511,5.852-3.512,17.557-16.386,26.918S4.729,45.234,1.224,39.382,4.729,21.825,17.61,11.29,43.36-1.585,45.7,4.268Z",
    transform: "translate(3.506 11.827)",
    fill: "#9f9ea7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1547",
    "data-name": "Path 1547",
    d: "M45.7,3.76c3.511,5.853-3.512,17.56-16.386,26.922S4.729,43.556,1.224,38.875,4.729,21.32,17.61,11.955,43.36-2.092,45.7,3.76Z",
    transform: "translate(3.506 12.333)",
    fill: "#9f9ea9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1548",
    "data-name": "Path 1548",
    d: "M45.7,3.76c3.511,5.853-3.512,17.56-16.386,26.922S4.729,43.556,1.224,38.875,4.729,21.32,17.61,11.955,43.36-2.092,45.7,3.76Z",
    transform: "translate(3.506 12.333)",
    fill: "#9f9ea9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1549",
    "data-name": "Path 1549",
    d: "M45.7,3.76c3.511,5.853-3.512,17.56-16.386,26.922S4.729,43.556,1.224,38.875,4.729,21.32,17.61,11.955,43.36-2.092,45.7,3.76Z",
    transform: "translate(3.506 12.333)",
    fill: "#9f9ea7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1550",
    "data-name": "Path 1550",
    d: "M45.7,3.76c3.511,5.853-3.512,17.56-16.386,26.922S4.729,43.556,1.224,38.875,4.729,21.32,17.61,11.955,42.189-2.092,45.7,3.76Z",
    transform: "translate(3.506 12.333)",
    fill: "#9f9ea7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    "data-name": "Path 1551",
    d: "M45.7,3.288c3.512,4.683-3.512,17.557-16.386,26.921S4.729,43.079,1.224,38.4s3.5-17.558,16.386-26.922S42.189-1.393,45.7,3.288Z",
    transform: "translate(3.506 12.805)",
    fill: "#a1a0aa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1552",
    "data-name": "Path 1552",
    d: "M45.7,3.288c3.512,5.852-3.512,17.557-16.386,26.921S4.729,43.079,1.224,38.4s3.5-17.558,16.386-26.922S42.189-1.393,45.7,3.288Z",
    transform: "translate(3.506 12.805)",
    fill: "#a2a0a8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1553",
    "data-name": "Path 1553",
    d: "M45.7,3.288c3.512,5.852-3.512,17.557-16.386,26.921S4.729,43.079,1.224,38.4s3.5-17.558,16.386-26.922S42.189-1.393,45.7,3.288Z",
    transform: "translate(3.506 12.805)",
    fill: "#a4a1aa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    "data-name": "Path 1554",
    d: "M45.7,3.288c3.512,5.852-3.512,17.557-16.386,26.921S4.729,43.079,1.224,38.4s3.5-17.558,16.386-26.922S42.189-1.393,45.7,3.288Z",
    transform: "translate(3.506 12.805)",
    fill: "#a4a1aa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1555",
    "data-name": "Path 1555",
    d: "M45.7,3.288c3.512,4.683-3.512,17.557-16.386,26.921S4.729,43.079,1.224,38.4s3.5-17.558,16.386-26.922S42.189-1.393,45.7,3.288Z",
    transform: "translate(3.506 12.805)",
    fill: "#a2a0a8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1556",
    "data-name": "Path 1556",
    d: "M45.7,3.288c3.512,4.683-3.512,17.557-16.386,26.921S4.729,43.079,1.224,38.4s3.5-17.558,16.386-26.922S42.189-1.393,45.7,3.288Z",
    transform: "translate(3.506 12.805)",
    fill: "#a4a2ab",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1557",
    "data-name": "Path 1557",
    d: "M45.7,3.288c3.512,4.683-3.512,17.557-16.386,26.921S4.729,43.079,1.224,38.4s3.5-17.558,16.386-26.922S42.189-1.393,45.7,3.288Z",
    transform: "translate(3.506 12.805)",
    fill: "#a4a2a9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1558",
    "data-name": "Path 1558",
    d: "M45.7,3.288c3.512,4.683-3.512,17.557-16.386,26.921S4.729,43.079,1.224,38.4s3.5-17.558,16.386-26.922S42.189-1.393,45.7,3.288Z",
    transform: "translate(3.506 12.805)",
    fill: "#a4a2a9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1559",
    "data-name": "Path 1559",
    d: "M45.7,3.288c3.512,4.683-3.512,17.557-16.386,26.921S4.729,43.079,1.224,38.4s3.5-17.558,16.386-26.922S42.189-1.393,45.7,3.288Z",
    transform: "translate(3.506 12.805)",
    fill: "#a4a2a9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1560",
    "data-name": "Path 1560",
    d: "M45.7,3.541C49.212,8.222,42.189,21.1,29.315,30.466S4.729,43.337,1.224,37.484s3.5-17.56,16.386-26.921S42.189-1.141,45.7,3.541Z",
    transform: "translate(3.506 12.554)",
    fill: "#a8a5aa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1561",
    "data-name": "Path 1561",
    d: "M45.7,3.541C49.212,8.222,42.189,21.1,29.315,30.466S4.729,43.337,1.224,37.484s3.5-17.56,16.386-26.921S42.189-1.141,45.7,3.541Z",
    transform: "translate(3.506 12.554)",
    fill: "#a8a5aa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1562",
    "data-name": "Path 1562",
    d: "M45.7,3.541C49.212,8.222,42.189,21.1,29.315,30.466S4.729,43.337,1.224,37.484s3.5-17.56,16.386-26.921S42.189-1.141,45.7,3.541Z",
    transform: "translate(3.506 12.554)",
    fill: "#a8a5aa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1563",
    "data-name": "Path 1563",
    d: "M45.7,3.541C49.212,9.393,42.189,21.1,29.315,30.466S4.729,43.337,1.224,37.484s3.5-17.56,16.386-26.921S42.189-1.141,45.7,3.541Z",
    transform: "translate(3.506 12.554)",
    fill: "#a8a5aa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1564",
    "data-name": "Path 1564",
    d: "M45.7,3.541C49.212,9.393,42.189,21.1,29.315,30.466S4.729,43.337,1.224,37.484s3.5-17.56,16.386-26.921S42.189-1.141,45.7,3.541Z",
    transform: "translate(3.506 12.554)",
    fill: "#a8a5aa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1565",
    "data-name": "Path 1565",
    d: "M45.7,4.419c3.512,4.683-3.512,17.557-15.216,25.75S4.729,43.044,1.224,37.191,4.729,19.637,17.61,10.27,42.189-1.435,45.7,4.419Z",
    transform: "translate(3.506 12.845)",
    fill: "#a8a8ac",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1566",
    "data-name": "Path 1566",
    d: "M45.708,4.419C49.22,9.1,42.2,21.976,30.492,30.169S4.741,43.044,1.229,37.191,4.741,19.637,16.446,10.27,42.2-1.435,45.708,4.419Z",
    transform: "translate(3.5 12.845)",
    fill: "#a8a5aa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1567",
    "data-name": "Path 1567",
    d: "M45.7,4.116c3.512,4.683-3.512,17.557-16.386,25.75S4.729,42.742,1.224,36.89,4.729,20.5,17.61,11.14,42.189-1.734,45.7,4.116Z",
    transform: "translate(3.506 13.148)",
    fill: "#aba9a9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1568",
    "data-name": "Path 1568",
    d: "M44.273,4.116C47.785,8.8,40.761,20.5,29.058,29.866S3.306,42.742.965,36.89,4.477,20.5,16.182,11.14,40.761-1.734,44.273,4.116Z",
    transform: "translate(4.934 13.148)",
    fill: "#aba9a9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1569",
    "data-name": "Path 1569",
    d: "M44.273,4.116C47.785,8.8,40.761,20.5,29.058,29.866S3.306,42.742.965,36.89,4.477,20.5,16.182,11.14,40.761-1.734,44.273,4.116Z",
    transform: "translate(4.934 13.148)",
    fill: "#aba9a9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1570",
    "data-name": "Path 1570",
    d: "M44.273,4.116C47.785,8.8,40.761,20.5,29.058,29.866S3.306,42.742.965,36.89,4.477,20.5,16.182,11.14,40.761-1.734,44.273,4.116Z",
    transform: "translate(4.934 13.148)",
    fill: "#aba9a9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1571",
    "data-name": "Path 1571",
    d: "M44.273,4.116C47.785,8.8,40.761,20.5,29.058,29.866S3.306,42.742.965,36.89,4.477,20.5,16.182,11.14,40.761-1.734,44.273,4.116Z",
    transform: "translate(4.934 13.148)",
    fill: "#afaaac",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1572",
    "data-name": "Path 1572",
    d: "M44.637,4.116C48.149,8.8,41.125,20.5,29.422,29.866S4.841,42.742,1.329,36.89,4.841,20.5,16.546,11.14,41.125-1.734,44.637,4.116Z",
    transform: "translate(4.57 13.148)",
    fill: "#ada8a8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1573",
    "data-name": "Path 1573",
    d: "M43.467,4.116C46.979,8.8,39.955,20.5,28.251,29.866S4.841,42.742,1.329,36.89,4.841,20.5,16.546,11.14,41.125-1.734,43.467,4.116Z",
    transform: "translate(4.57 13.148)",
    fill: "#ada8a8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1574",
    "data-name": "Path 1574",
    d: "M43.467,4.116C46.979,8.8,39.955,20.5,28.251,29.866S4.841,41.571,1.329,36.89,4.841,20.5,16.546,11.14,41.125-1.734,43.467,4.116Z",
    transform: "translate(4.57 13.148)",
    fill: "#ada9a7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1575",
    "data-name": "Path 1575",
    d: "M43.467,4.116C46.979,8.8,39.955,20.5,28.251,29.866S4.841,42.742,1.329,36.89,4.841,20.5,16.546,11.14,41.125-1.734,43.467,4.116Z",
    transform: "translate(4.57 13.148)",
    fill: "#afacaa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    "data-name": "Path 1576",
    d: "M43.467,4.116C46.979,8.8,39.955,20.5,28.251,29.866S4.841,42.742,1.329,36.89,4.841,20.5,16.546,11.14,41.125-1.734,43.467,4.116Z",
    transform: "translate(4.57 13.148)",
    fill: "#afacaa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1577",
    "data-name": "Path 1577",
    d: "M43.467,4.116C46.979,8.8,39.955,20.5,28.251,29.866S4.841,42.742,1.329,36.89,4.841,20.5,16.546,11.14,41.125-1.734,43.467,4.116Z",
    transform: "translate(4.57 13.148)",
    fill: "#afadab",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1578",
    "data-name": "Path 1578",
    d: "M43.467,3.641c3.512,4.683-3.512,16.386-15.216,25.75S4.841,42.267,1.329,36.414s3.512-16.389,15.217-25.75S39.955-1.041,43.467,3.641Z",
    transform: "translate(4.57 13.623)",
    fill: "#afadab",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1579",
    "data-name": "Path 1579",
    d: "M43.467,3.641c3.512,4.683-3.512,16.386-15.216,25.75S4.841,41.1,1.329,36.414s3.512-16.389,15.217-25.75S39.955-1.041,43.467,3.641Z",
    transform: "translate(4.57 13.623)",
    fill: "#afada8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1580",
    "data-name": "Path 1580",
    d: "M43.467,3.641c3.512,4.683-3.512,16.386-15.216,25.75S4.841,41.1,1.329,36.414s3.512-16.389,15.217-25.75S39.955-1.041,43.467,3.641Z",
    transform: "translate(4.57 13.623)",
    fill: "#b1aeab",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1581",
    "data-name": "Path 1581",
    d: "M43.467,3.641c3.512,4.683-3.512,16.386-15.216,25.75S4.841,42.267,1.329,36.414s3.512-16.389,15.217-25.75S39.955-1.041,43.467,3.641Z",
    transform: "translate(4.57 13.623)",
    fill: "#b1aeab",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    "data-name": "Path 1582",
    d: "M43.467,3.641c3.512,4.683-3.512,16.386-15.216,25.75S4.841,41.1,1.329,36.414s3.512-16.389,15.217-25.75S39.955-1.041,43.467,3.641Z",
    transform: "translate(4.57 13.623)",
    fill: "#b1aeab",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1583",
    "data-name": "Path 1583",
    d: "M43.467,3.641c3.512,4.683-3.512,16.386-15.216,25.75S4.841,41.1,1.329,36.414s3.512-16.389,15.217-25.75S39.955-1.041,43.467,3.641Z",
    transform: "translate(4.57 13.623)",
    fill: "#b1aea9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1584",
    "data-name": "Path 1584",
    d: "M43.467,3.641c3.512,4.683-3.512,16.386-15.216,25.75S4.841,41.1,1.329,36.414s3.512-16.389,15.217-25.75S39.955-1.041,43.467,3.641Z",
    transform: "translate(4.57 13.623)",
    fill: "#b4b0aa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    "data-name": "Path 1585",
    d: "M43.467,3.641c3.512,4.683-3.512,16.386-15.216,25.75S4.841,41.1,1.329,36.414s3.512-16.389,15.217-25.75S39.955-1.041,43.467,3.641Z",
    transform: "translate(4.57 13.623)",
    fill: "#b2aea8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    "data-name": "Path 1586",
    d: "M43.467,3.946c3.512,4.683-3.512,16.386-15.216,24.579S4.841,40.231,1.329,35.55,4.841,19.162,16.546,9.8,39.955-.736,43.467,3.946Z",
    transform: "translate(4.57 13.317)",
    fill: "#b4b0aa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    "data-name": "Path 1587",
    d: "M43.467,3.417C46.979,8.1,39.955,19.8,28.251,28S4.841,39.7,1.329,35.019s3.512-16.39,15.217-24.574S39.955-1.265,43.467,3.417Z",
    transform: "translate(4.57 13.847)",
    fill: "#b4b2a9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    d: "M43.467,3.417C46.979,8.1,39.955,19.8,28.251,28S4.841,39.7,1.329,35.019s3.512-16.39,15.217-24.574S39.955-1.265,43.467,3.417Z",
    transform: "translate(4.57 13.847)",
    fill: "#b4b0a8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    d: "M42.032,3.417C45.544,8.1,38.52,19.8,26.816,28S3.406,39.7,1.065,35.019s3.512-16.39,15.217-24.574S38.52-1.265,42.032,3.417Z",
    transform: "translate(6.005 13.847)",
    fill: "#b6b2a9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M42.032,3.417C45.544,8.1,38.52,19.8,26.816,28S3.406,39.7,1.065,35.019s3.512-16.39,15.217-24.574S38.52-1.265,42.032,3.417Z",
    transform: "translate(6.005 13.847)",
    fill: "#b4b2a9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M42.032,3.417C45.544,8.1,38.52,19.8,26.816,28S3.406,39.7,1.065,35.019s3.512-16.39,15.217-24.574S38.52-1.265,42.032,3.417Z",
    transform: "translate(6.005 13.847)",
    fill: "#b4b2a9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    d: "M42.032,3.417C45.544,8.1,38.52,19.8,26.816,28S3.406,39.7,1.065,35.019s3.512-16.39,15.217-24.574S38.52-1.265,42.032,3.417Z",
    transform: "translate(6.005 13.847)",
    fill: "#b6b4aa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    d: "M42.032,3.641C45.544,8.324,38.52,20.027,26.816,28.22S3.406,39.926,1.065,35.243,4.577,20.025,16.282,10.664,38.52-1.041,42.032,3.641Z",
    transform: "translate(6.005 13.623)",
    fill: "#b6b4aa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1594",
    "data-name": "Path 1594",
    d: "M42.032,3.641C45.544,8.324,38.52,20.027,26.816,28.22S3.406,39.926,1.065,35.243,4.577,20.025,16.282,10.664,38.52-1.041,42.032,3.641Z",
    transform: "translate(6.005 13.623)",
    fill: "#b6b4a7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    d: "M42.032,3.641C45.544,8.324,38.52,18.857,26.816,28.22S3.406,39.926,1.065,35.243,4.577,20.025,16.282,10.664,38.52-1.041,42.032,3.641Z",
    transform: "translate(6.005 13.623)",
    fill: "#b6b4a7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1596",
    "data-name": "Path 1596",
    d: "M42.032,3.641C44.373,8.324,38.52,18.857,26.816,28.22S3.406,39.926,1.065,35.243,4.577,20.025,16.282,10.664,38.52-1.041,42.032,3.641Z",
    transform: "translate(6.005 13.623)",
    fill: "#b8b4a7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M42.032,3.641C45.544,8.324,38.52,18.857,26.816,28.22S3.406,39.926,1.065,35.243,4.577,20.025,16.282,10.664,38.52-1.041,42.032,3.641Z",
    transform: "translate(6.005 13.623)",
    fill: "#b8b4a7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    d: "M42.032,3.641C45.544,8.324,38.52,18.857,26.816,28.22S3.406,39.926,1.065,35.243,4.577,20.025,16.282,10.664,38.52-1.041,42.032,3.641Z",
    transform: "translate(6.005 13.623)",
    fill: "#bbb5a9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    d: "M42.221,3.641c3.512,4.683-3.512,15.216-15.216,24.579S4.766,39.926,1.254,35.243,5.937,20.025,16.471,10.664,39.88-1.041,42.221,3.641Z",
    transform: "translate(4.645 13.623)",
    fill: "#bbb5a9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    d: "M41.225,3.641c3.512,5.852-3.511,16.383-14.045,24.579S4.941,39.926,1.429,35.243,4.941,20.025,16.646,10.664,38.884-1.041,41.225,3.641Z",
    transform: "translate(5.641 13.623)",
    fill: "#b8b4a7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M42.221,3.641c2.341,5.852-3.512,16.383-15.216,24.579S4.766,39.926,1.254,35.243,5.937,20.025,16.471,10.664,39.88-1.041,42.221,3.641Z",
    transform: "translate(4.645 13.623)",
    fill: "#bdb7a9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M42.3,4.519C45.808,9.2,38.784,19.737,27.081,27.927S4.841,39.632,1.329,34.951,4.841,19.737,16.546,10.37,39.955-1.335,42.3,4.519Z",
    transform: "translate(4.57 13.916)",
    fill: "#bbb5a7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    d: "M42.3,3.517C44.637,8.2,38.784,18.729,27.081,26.926S4.841,38.631,1.329,33.95s3.512-15.221,15.217-23.4S39.955-1.165,42.3,3.517Z",
    transform: "translate(4.57 14.917)",
    fill: "#bbb5a7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    d: "M41.231,3.517C44.737,8.2,37.72,18.729,27.186,26.926S4.946,38.631,1.436,33.95s3.511-15.221,14.045-23.4S38.891-1.165,41.231,3.517Z",
    transform: "translate(5.636 14.917)",
    fill: "#bdb7a8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1605",
    "data-name": "Path 1605",
    d: "M41.231,3.517C43.572,8.2,37.72,18.729,27.186,26.926S4.946,38.631,1.436,33.95s3.511-15.221,14.045-23.4S38.891-1.165,41.231,3.517Z",
    transform: "translate(5.636 14.917)",
    fill: "#bdb7a8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    d: "M41.231,3.517C43.572,8.2,37.72,18.729,27.186,26.926S4.946,38.631,1.436,33.95s3.511-15.221,14.045-23.4S38.891-1.165,41.231,3.517Z",
    transform: "translate(5.636 14.917)",
    fill: "#bdb7a5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    d: "M41.231,3.517C43.572,8.2,37.72,18.729,27.186,26.926S4.946,38.631,1.436,33.95s3.511-15.221,14.045-23.4S38.891-1.165,41.231,3.517Z",
    transform: "translate(5.636 14.917)",
    fill: "#bfbaa9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    d: "M41.231,3.517C43.572,8.2,37.72,18.729,27.186,26.926S4.946,38.631,1.436,33.95s3.511-15.221,14.045-23.4S38.891-1.165,41.231,3.517Z",
    transform: "translate(5.636 14.917)",
    fill: "#bdb9a5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1609",
    "data-name": "Path 1609",
    d: "M41.231,3.517C43.572,8.2,37.72,18.729,27.186,26.926S4.946,38.631,1.436,33.95s3.511-15.221,14.045-23.4S38.891-1.165,41.231,3.517Z",
    transform: "translate(5.636 14.917)",
    fill: "#bdb9a5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1610",
    "data-name": "Path 1610",
    d: "M39.795,3.517c2.34,4.681-3.512,15.211-14.046,23.409S3.509,38.631,1.169,33.95s3.511-15.221,14.045-23.4S37.453-1.165,39.795,3.517Z",
    transform: "translate(7.073 14.917)",
    fill: "#c0bba8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1611",
    "data-name": "Path 1611",
    d: "M39.795,3.517c2.34,4.681-3.512,15.211-14.046,23.409S3.509,38.631,1.169,33.95s3.511-15.221,14.045-23.4S37.453-1.165,39.795,3.517Z",
    transform: "translate(7.073 14.917)",
    fill: "#c0bba8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1612",
    "data-name": "Path 1612",
    d: "M39.795,3.517c2.34,4.681-3.512,15.211-14.046,23.409S3.509,38.631,1.169,33.95s3.511-15.221,14.045-23.4S37.453-1.165,39.795,3.517Z",
    transform: "translate(7.073 14.917)",
    fill: "#c0baa5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1613",
    "data-name": "Path 1613",
    d: "M39.795,3.517c2.34,4.681-3.512,15.211-14.046,23.409S3.509,38.631,1.169,33.95s3.511-15.221,14.045-23.4S36.283-1.165,39.795,3.517Z",
    transform: "translate(7.073 14.917)",
    fill: "#c0baa5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1614",
    "data-name": "Path 1614",
    d: "M39.795,3.517c2.34,4.681-3.512,15.211-14.046,23.409S3.509,38.631,1.169,33.95s3.511-15.221,14.045-23.4S36.283-1.165,39.795,3.517Z",
    transform: "translate(7.073 14.917)",
    fill: "#c2bca6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1615",
    "data-name": "Path 1615",
    d: "M39.795,3.517c2.34,4.681-3.512,15.211-14.046,23.409S3.509,38.631,1.169,33.95s3.511-15.221,14.045-23.4S36.283-1.165,39.795,3.517Z",
    transform: "translate(7.073 14.917)",
    fill: "#c0baa5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1616",
    "data-name": "Path 1616",
    d: "M39.795,3.517c2.34,4.681-3.512,15.211-14.046,23.409S3.509,38.631,1.169,33.95s3.511-15.221,14.045-23.4S36.283-1.165,39.795,3.517Z",
    transform: "translate(7.073 14.917)",
    fill: "#c0baa5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1617",
    "data-name": "Path 1617",
    d: "M39.795,3.517c2.34,4.681-3.512,15.211-14.046,23.409S3.509,38.631,1.169,33.95s3.511-15.221,14.045-23.4S36.283-1.165,39.795,3.517Z",
    transform: "translate(7.073 14.917)",
    fill: "#c2bea7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    "data-name": "Path 1618",
    d: "M39.795,3.517c2.34,4.681-3.512,15.211-14.046,23.409S3.509,38.631,1.169,33.95s3.511-15.221,14.045-23.4S36.283-1.165,39.795,3.517Z",
    transform: "translate(7.073 14.917)",
    fill: "#c4bea7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1619",
    "data-name": "Path 1619",
    d: "M39.795,3.517c2.34,4.681-3.512,15.211-14.046,23.409S3.509,38.631,1.169,33.95s3.511-15.221,14.045-23.4S36.283-1.165,39.795,3.517Z",
    transform: "translate(7.073 14.917)",
    fill: "#c4bea7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1620",
    "data-name": "Path 1620",
    d: "M39.795,3.517c2.34,4.681-3.512,15.211-14.046,23.409S3.509,38.631,1.169,33.95s3.511-15.221,14.045-23.4S36.283-1.165,39.795,3.517Z",
    transform: "translate(7.073 14.917)",
    fill: "#c4bea7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1621",
    "data-name": "Path 1621",
    d: "M39.795,3.517c2.34,4.681-3.512,15.211-14.046,23.409S3.509,38.631,1.169,33.95s3.511-15.221,14.045-23.4S36.283-1.165,39.795,3.517Z",
    transform: "translate(7.073 14.917)",
    fill: "#c4bea5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1622",
    "data-name": "Path 1622",
    d: "M40.16,3.741C42.5,8.422,36.654,18.957,26.112,27.15S5.046,38.849,1.536,34.174s3.511-14.049,14.045-23.41S36.654-.941,40.16,3.741Z",
    transform: "translate(6.706 14.693)",
    fill: "#c4bea5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1623",
    "data-name": "Path 1623",
    d: "M40.16,3.741C42.5,8.422,36.654,18.957,26.112,27.15S5.046,38.849,1.536,34.174s3.511-14.049,14.045-23.41S36.654-.941,40.16,3.741Z",
    transform: "translate(6.706 14.693)",
    fill: "#c4bea5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1624",
    "data-name": "Path 1624",
    d: "M40.16,3.517C42.5,8.2,36.654,18.729,26.112,26.926S5.046,38.631,1.536,33.95s3.511-15.221,14.045-23.4S36.654-1.165,40.16,3.517Z",
    transform: "translate(6.706 14.917)",
    fill: "#c5bea4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1625",
    "data-name": "Path 1625",
    d: "M40.06,3.517C42.4,8.2,36.554,18.729,26.012,26.926S4.946,38.631,1.436,33.95s3.511-15.221,14.045-23.4S37.72-1.165,40.06,3.517Z",
    transform: "translate(5.636 14.917)",
    fill: "#c7c1a4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1626",
    "data-name": "Path 1626",
    d: "M40.06,3.517C43.572,8.2,36.554,18.729,26.012,26.926S4.946,38.631,1.436,33.95s3.511-15.221,14.045-23.4S37.72-1.165,40.06,3.517Z",
    transform: "translate(5.636 14.917)",
    fill: "#c9c1a3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1627",
    "data-name": "Path 1627",
    d: "M39.98,3.04c3.506,4.688-3.511,15.223-14.045,23.416S4.866,38.161,1.354,33.478s4.683-15.216,15.217-23.41S37.639-.465,39.98,3.04Z",
    transform: "translate(5.716 15.389)",
    fill: "#c7c1a4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1628",
    "data-name": "Path 1628",
    d: "M38.624,3.04c3.511,4.688-3.509,15.223-14.051,23.416S3.509,38.161,1.169,33.478s3.511-15.216,14.045-23.41S36.283-.465,38.624,3.04Z",
    transform: "translate(7.073 15.389)",
    fill: "#c9c3a5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1629",
    "data-name": "Path 1629",
    d: "M38.624,3.04c3.511,4.688-3.509,15.223-14.051,23.416S3.509,38.161,1.169,33.478s3.511-15.216,14.045-23.41S36.283-.465,38.624,3.04Z",
    transform: "translate(7.073 15.389)",
    fill: "#c9c3a5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1630",
    "data-name": "Path 1630",
    d: "M38.624,3.04c3.511,4.688-3.509,15.223-14.051,23.416S3.509,38.161,1.169,33.478s3.511-15.216,14.045-23.41S36.283-.465,38.624,3.04Z",
    transform: "translate(7.073 15.389)",
    fill: "#c7c0a1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1631",
    "data-name": "Path 1631",
    d: "M38.624,3.04c3.511,4.688-3.509,15.223-14.051,23.416S3.509,36.99,1.169,33.478s3.511-15.216,14.045-23.41S36.283-.465,38.624,3.04Z",
    transform: "translate(7.073 15.389)",
    fill: "#c9c3a3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1632",
    "data-name": "Path 1632",
    d: "M38.624,3.04c3.511,4.688-3.509,15.223-14.051,23.416S3.509,36.99,1.169,33.478s3.511-15.216,14.045-23.41S36.283-.465,38.624,3.04Z",
    transform: "translate(7.073 15.389)",
    fill: "#c9c3a3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1633",
    "data-name": "Path 1633",
    d: "M38.624,3.04c3.511,4.688-3.509,15.223-14.051,23.416S3.509,36.99,1.169,33.478s3.511-15.216,14.045-23.41S36.283-.465,38.624,3.04Z",
    transform: "translate(7.073 15.389)",
    fill: "#cac3a0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1634",
    "data-name": "Path 1634",
    d: "M38.624,3.04c2.34,4.688-3.509,15.223-14.051,23.416S3.509,36.99,1.169,33.478s3.511-15.216,14.045-23.41S36.283-.465,38.624,3.04Z",
    transform: "translate(7.073 15.389)",
    fill: "#cac3a0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1635",
    "data-name": "Path 1635",
    d: "M38.991,3.883c2.341,3.512-3.512,14.046-14.046,22.239S5.046,36.655,1.536,31.974,5.046,17.928,15.581,9.735,36.654-.8,38.991,3.883Z",
    transform: "translate(6.706 15.722)",
    fill: "#ccc5a1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    d: "M38.991,3.883c2.341,3.512-3.512,14.046-14.046,22.239S5.046,36.655,1.536,31.974,5.046,17.928,15.581,9.735,36.654-.8,38.991,3.883Z",
    transform: "translate(6.706 15.722)",
    fill: "#ccc5a1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    "data-name": "Path 1637",
    d: "M38.991,3.883c2.341,3.512-3.512,14.046-14.046,21.069s-19.9,11.7-23.409,7.022S5.046,17.928,15.581,9.735,36.654-.8,38.991,3.883Z",
    transform: "translate(6.706 15.722)",
    fill: "#ccc7a1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    d: "M38.991,3.883c2.341,3.512-3.512,14.046-14.046,21.069s-19.9,11.7-23.409,7.022S5.046,17.928,15.581,9.735,36.654-.8,38.991,3.883Z",
    transform: "translate(6.706 15.722)",
    fill: "#ccc7a1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    d: "M38.991,3.883c2.341,3.512-3.512,14.046-14.046,21.069s-19.9,11.7-23.409,7.022S5.046,17.928,15.581,9.735,36.654-.8,38.991,3.883Z",
    transform: "translate(6.706 15.722)",
    fill: "#ccc5a1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    d: "M38.991,3.883c2.341,3.512-3.512,14.046-14.046,21.069s-19.9,11.7-23.409,7.022S5.046,17.928,15.581,9.735,36.654-.8,38.991,3.883Z",
    transform: "translate(6.706 15.722)",
    fill: "#ccc5a1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    d: "M38.991,3.883c2.341,3.512-3.512,14.046-14.046,21.069s-19.9,11.7-23.409,7.022S5.046,17.928,15.581,9.735,36.654-.8,38.991,3.883Z",
    transform: "translate(6.706 15.722)",
    fill: "#cec69f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    d: "M38.991,3.883c2.341,3.512-3.512,14.046-14.046,21.069s-19.9,11.7-23.409,7.022S5.046,17.928,15.581,9.735,36.654-.8,38.991,3.883Z",
    transform: "translate(6.706 15.722)",
    fill: "#cec69f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    d: "M37.626,3.883c2.341,3.512-3.512,14.046-14.046,21.069s-19.9,11.7-22.239,7.022S3.681,17.928,14.216,9.735,35.284-.8,37.626,3.883Z",
    transform: "translate(8.071 15.722)",
    fill: "#cec69f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1644",
    "data-name": "Path 1644",
    d: "M37.626,3.883c2.341,3.512-3.512,14.046-14.046,21.069s-19.9,11.7-22.239,7.022S3.681,17.928,14.216,9.735,34.108-.8,37.626,3.883Z",
    transform: "translate(8.071 15.722)",
    fill: "#d1c89e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1645",
    "data-name": "Path 1645",
    d: "M37.626,3.883c2.341,3.512-3.512,14.046-14.046,21.069s-19.9,11.7-22.239,7.022S3.681,17.928,14.216,9.735,34.108-.8,37.626,3.883Z",
    transform: "translate(8.071 15.722)",
    fill: "#cfc79e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1646",
    "data-name": "Path 1646",
    d: "M37.626,3.883c2.341,3.512-3.512,14.046-14.046,21.069S3.681,35.483,1.34,31.974,3.681,17.928,14.216,9.735,34.108-.8,37.626,3.883Z",
    transform: "translate(8.071 15.722)",
    fill: "#cfc79b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1647",
    "data-name": "Path 1647",
    d: "M37.626,3.883c2.341,4.683-3.512,14.046-12.876,21.069S3.681,35.483,1.34,31.974,3.681,17.928,14.216,9.735,34.108-.8,37.626,3.883Z",
    transform: "translate(8.071 15.722)",
    fill: "#cfc79b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1648",
    "data-name": "Path 1648",
    d: "M36.455,3.883c3.512,3.512-2.341,14.046-12.876,21.069S3.681,35.483,1.34,31.974,3.681,17.928,14.216,9.735,34.108-.8,36.455,3.883Z",
    transform: "translate(8.071 15.722)",
    fill: "#d1c99b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1649",
    "data-name": "Path 1649",
    d: "M36.386,2.959C39.9,6.471,34.045,17.005,23.51,24.028S3.613,34.562,1.272,31.052,4.784,17,14.148,9.983,34.046-.551,36.386,2.959Z",
    transform: "translate(8.139 16.645)",
    fill: "#d1c99b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1650",
    "data-name": "Path 1650",
    d: "M36.386,2.959C39.9,6.471,34.045,17.005,23.51,24.028S3.613,34.562,1.272,31.052,4.784,17,14.148,9.983,34.046-.551,36.386,2.959Z",
    transform: "translate(8.139 16.645)",
    fill: "#d4cc9c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1651",
    "data-name": "Path 1651",
    d: "M36.386,2.959C39.9,6.471,34.045,17.005,23.51,24.028S3.613,34.562,1.272,31.052,4.784,17,14.148,9.983,34.046-.551,36.386,2.959Z",
    transform: "translate(8.139 16.645)",
    fill: "#d4cc9c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1652",
    "data-name": "Path 1652",
    d: "M36.386,2.959c2.341,3.512-3.512,14.046-12.876,21.069S3.613,34.562,1.272,31.052,4.784,17,14.148,9.983,34.046-.551,36.386,2.959Z",
    transform: "translate(8.139 16.645)",
    fill: "#d4ca99",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1653",
    "data-name": "Path 1653",
    d: "M36.386,2.959c2.341,3.512-3.512,14.046-12.876,21.069S3.613,34.562,1.272,31.052,4.784,17,14.148,9.983,34.046-.551,36.386,2.959Z",
    transform: "translate(8.139 16.645)",
    fill: "#d4ca98",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1654",
    "data-name": "Path 1654",
    d: "M36.386,2.959c2.341,4.683-3.512,14.046-12.876,21.069S3.613,34.562,1.272,31.052,4.784,17,14.148,9.983,34.046-.551,36.386,2.959Z",
    transform: "translate(8.139 16.645)",
    fill: "#d4ca99",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1655",
    "data-name": "Path 1655",
    d: "M36.386,2.959c2.341,4.683-3.512,14.046-12.876,21.069S3.613,34.562,1.272,31.052,4.784,17,14.148,9.983,34.046-.551,36.386,2.959Z",
    transform: "translate(8.139 16.645)",
    fill: "#d4ca99",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1656",
    "data-name": "Path 1656",
    d: "M36.386,2.959c2.341,4.683-3.512,14.046-12.876,21.069S3.613,34.562,1.272,31.052,4.784,17,14.148,9.983,34.046-.551,36.386,2.959Z",
    transform: "translate(8.139 16.645)",
    fill: "#d4ca96",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    d: "M36.386,3.14c2.341,4.683-3.512,14.046-12.876,21.069s-19.9,10.54-22.238,7.028S4.784,18.361,14.148,10.168,34.046-.365,36.386,3.14Z",
    transform: "translate(8.139 16.46)",
    fill: "#d6ce97",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1658",
    "data-name": "Path 1658",
    d: "M36.386,3.14c2.341,4.683-3.512,14.046-12.876,21.069s-19.9,10.54-22.238,7.028S4.784,18.361,14.148,10.168,34.046-.365,36.386,3.14Z",
    transform: "translate(8.139 16.46)",
    fill: "#d8cf99",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1659",
    "data-name": "Path 1659",
    d: "M36.386,3.14c2.341,4.683-3.512,14.046-12.876,21.069s-19.9,10.54-22.238,7.028S4.784,18.361,14.148,10.168,34.046-.365,36.386,3.14Z",
    transform: "translate(8.139 16.46)",
    fill: "#d9cf97",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    d: "M36.386,3.14c2.341,4.683-3.512,14.046-12.876,21.069s-19.9,10.54-22.238,7.028S4.784,18.361,14.148,10.168,34.046-.365,36.386,3.14Z",
    transform: "translate(8.139 16.46)",
    fill: "#d9cf97",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    d: "M36.386,3.14c2.341,4.683-3.512,14.046-12.876,21.069s-19.9,10.54-22.238,7.028S4.784,18.361,14.148,10.168,34.046-.365,36.386,3.14Z",
    transform: "translate(8.139 16.46)",
    fill: "#d9cd93",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M36.386,3.14c2.341,4.683-3.512,14.046-12.876,21.069s-19.9,10.54-22.238,7.028S4.784,18.361,14.148,10.168,34.046-.365,36.386,3.14Z",
    transform: "translate(8.139 16.46)",
    fill: "#d9cf94",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M36.386,3.14c2.341,4.683-3.512,14.046-12.876,21.069s-19.9,10.54-22.238,7.028S4.784,18.361,14.148,10.168,34.046-.365,36.386,3.14Z",
    transform: "translate(8.139 16.46)",
    fill: "#d9cf94",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    d: "M36.386,3.406c2.341,4.683-3.512,14.046-12.876,21.069S3.613,35.009,1.272,30.334,4.784,17.458,14.148,9.265,34.046-.1,36.386,3.406Z",
    transform: "translate(8.139 16.199)",
    fill: "#dbd395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1665",
    "data-name": "Path 1665",
    d: "M36.386,4.3C38.727,7.816,32.874,17.18,23.51,24.2S3.613,34.737,1.272,30.055,4.784,17.18,14.148,8.987,34.046-.377,36.386,4.3Z",
    transform: "translate(8.139 16.471)",
    fill: "#dbd395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1666",
    "data-name": "Path 1666",
    d: "M36.386,4.3C38.727,7.816,32.874,17.18,23.51,24.2S3.613,34.737,1.272,30.055,4.784,17.18,14.148,8.987,34.046-.377,36.386,4.3Z",
    transform: "translate(8.139 16.471)",
    fill: "#d9d291",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1667",
    "data-name": "Path 1667",
    d: "M36.386,3.75c2.341,3.512-3.512,12.876-12.876,19.9S3.613,34.188,1.272,29.5,4.784,16.624,14.148,9.6,34.046-.933,36.386,3.75Z",
    transform: "translate(8.139 17.026)",
    fill: "#d9ce90",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1668",
    "data-name": "Path 1668",
    d: "M36.386,3.75c2.341,3.512-3.512,12.876-12.876,19.9S3.613,34.188,1.272,29.5,4.784,16.624,14.148,9.6,34.046-.933,36.386,3.75Z",
    transform: "translate(8.139 17.026)",
    fill: "#dbd393",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1669",
    "data-name": "Path 1669",
    d: "M35.006,3.75c2.341,3.511-3.512,12.874-12.878,19.9S2.232,34.188,1.061,29.5,4.573,16.624,13.937,9.6,32.669-.933,35.006,3.75Z",
    transform: "translate(9.521 17.026)",
    fill: "#dbd391",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1670",
    "data-name": "Path 1670",
    d: "M35.316,3.75c2.341,3.512-3.512,12.876-12.876,19.9S3.715,33.012,1.371,29.5,4.885,16.624,14.248,9.6,32.976-.933,35.316,3.75Z",
    transform: "translate(9.209 17.026)",
    fill: "#dbd391",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1671",
    "data-name": "Path 1671",
    d: "M35.316,3.75c2.341,3.512-3.512,12.876-12.876,19.9S3.715,33.012,1.371,29.5,4.885,16.624,14.248,9.6,32.976-.933,35.316,3.75Z",
    transform: "translate(9.209 17.026)",
    fill: "#e0d291",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1672",
    "data-name": "Path 1672",
    d: "M35.316,3.75c2.341,3.512-3.512,12.876-12.876,19.9S3.715,33.012,1.371,29.5,4.885,16.624,14.248,9.6,32.976-.933,35.316,3.75Z",
    transform: "translate(9.209 17.026)",
    fill: "#e0d48e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1673",
    "data-name": "Path 1673",
    d: "M35.316,3.75c2.341,3.512-3.512,12.876-12.876,19.9S3.715,33.012,1.371,29.5,4.885,16.624,14.248,9.6,31.805-.933,35.316,3.75Z",
    transform: "translate(9.209 17.026)",
    fill: "#e0d48e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1674",
    "data-name": "Path 1674",
    d: "M35.316,3.275c2.341,3.512-3.512,12.876-12.876,19.9S3.715,32.537,1.371,29.025s3.513-12.874,12.877-19.9S31.805-.236,35.316,3.275Z",
    transform: "translate(9.209 17.501)",
    fill: "#e0d48c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1675",
    "data-name": "Path 1675",
    d: "M35.316,3.275c2.341,3.512-3.512,12.876-12.876,19.9S3.715,32.537,1.371,29.025s3.513-12.874,12.877-19.9S31.805-.236,35.316,3.275Z",
    transform: "translate(9.209 17.501)",
    fill: "#ded58b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1676",
    "data-name": "Path 1676",
    d: "M35.316,3.275c2.341,3.512-3.512,12.876-12.876,19.9S3.715,32.537,1.371,29.025s3.513-12.874,12.877-19.9S31.805-.236,35.316,3.275Z",
    transform: "translate(9.209 17.501)",
    fill: "#ded58b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1677",
    "data-name": "Path 1677",
    d: "M34.146,3.275c3.512,3.512-2.341,12.876-11.705,19.9S3.716,32.537,1.372,29.025s3.512-12.874,12.876-19.9S31.8-.236,34.146,3.275Z",
    transform: "translate(9.21 17.501)",
    fill: "#ded58b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1678",
    "data-name": "Path 1678",
    d: "M34.146,3.275c2.341,3.512-3.512,12.876-12.876,19.9s-17.557,9.364-19.9,5.853,3.512-12.876,12.876-19.9S31.8-.236,34.146,3.275Z",
    transform: "translate(9.21 17.501)",
    fill: "#ded58b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1679",
    "data-name": "Path 1679",
    d: "M34.146,3.275c2.341,3.512-3.512,12.876-12.876,19.9s-17.557,9.364-19.9,5.853,3.512-12.876,12.876-19.9S31.8-.236,34.146,3.275Z",
    transform: "translate(9.21 17.501)",
    fill: "#e1d78b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1680",
    "data-name": "Path 1680",
    d: "M34.146,3.275c2.341,3.512-3.512,12.876-12.876,19.9s-17.557,9.364-19.9,5.853,3.512-12.876,12.876-19.9S31.8-.236,34.146,3.275Z",
    transform: "translate(9.21 17.501)",
    fill: "#e1d488",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1681",
    "data-name": "Path 1681",
    d: "M34.146,3.275c2.341,3.512-3.512,12.876-12.876,19.9s-17.557,9.364-19.9,5.853,3.512-12.876,12.876-19.9S31.8-.236,34.146,3.275Z",
    transform: "translate(9.21 17.501)",
    fill: "#e3d588",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1682",
    "data-name": "Path 1682",
    d: "M34.149,3.275c2.341,3.512-3.512,12.876-11.705,19.9S3.719,32.537,1.375,29.025,4.887,16.151,13.08,9.128,31.808-.236,34.149,3.275Z",
    transform: "translate(9.206 17.501)",
    fill: "#e3d588",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1683",
    "data-name": "Path 1683",
    d: "M34.149,3.275c2.341,3.512-3.512,12.876-11.705,19.9S3.719,32.537,1.375,29.025,4.887,16.151,13.08,9.128,31.808-.236,34.149,3.275Z",
    transform: "translate(9.206 17.501)",
    fill: "#e3d685",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1684",
    "data-name": "Path 1684",
    d: "M34.149,3.507c2.341,3.512-3.512,12.876-11.705,19.9S3.719,32.769,1.375,29.257s3.512-11.7,11.705-19.9S31.808,0,34.149,3.507Z",
    transform: "translate(9.206 17.269)",
    fill: "#e3d685",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1685",
    "data-name": "Path 1685",
    d: "M34.149,3.507c2.341,3.512-3.512,11.705-11.705,19.9S3.719,32.769,1.375,29.257s3.512-11.7,11.705-19.9S31.808,0,34.149,3.507Z",
    transform: "translate(9.206 17.269)",
    fill: "#e4d886",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1686",
    "data-name": "Path 1686",
    d: "M34.149,3.507c2.341,3.512-3.512,11.705-11.705,19.9S3.719,32.769,1.375,29.257s3.512-11.7,11.705-19.9S31.808,0,34.149,3.507Z",
    transform: "translate(9.206 17.269)",
    fill: "#e4d884",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1687",
    "data-name": "Path 1687",
    d: "M34.149,3.059c2.341,3.512-3.512,11.705-11.705,19.9S3.719,32.321,1.375,28.809,4.887,17.1,13.08,10.083,31.808-.451,34.149,3.059Z",
    transform: "translate(9.206 17.715)",
    fill: "#e4d884",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1688",
    "data-name": "Path 1688",
    d: "M34.149,3.059c2.341,3.512-3.512,11.705-11.705,18.725S3.719,32.318,1.375,28.806,4.887,17.1,13.08,10.083,31.808-.451,34.149,3.059Z",
    transform: "translate(9.206 17.715)",
    fill: "#e6da82",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1689",
    "data-name": "Path 1689",
    d: "M34.149,3.059c2.341,3.512-3.512,11.705-11.705,18.725S3.719,32.318,1.375,28.806,4.887,17.1,13.08,10.083,31.808-.451,34.149,3.059Z",
    transform: "translate(9.206 17.715)",
    fill: "#e6da7e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1690",
    "data-name": "Path 1690",
    d: "M34.149,3.059c2.341,3.512-3.512,11.705-11.705,18.725S3.719,32.318,1.375,28.806,4.887,17.1,13.08,10.083,31.808-.451,34.149,3.059Z",
    transform: "translate(9.206 17.715)",
    fill: "#e6da7e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1691",
    "data-name": "Path 1691",
    d: "M34.149,3.059c2.341,3.512-3.512,11.705-11.705,18.725S3.719,32.318,1.375,28.806,4.887,17.1,13.08,10.083,31.808-.451,34.149,3.059Z",
    transform: "translate(9.206 17.715)",
    fill: "#e6da7e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1692",
    "data-name": "Path 1692",
    d: "M34.149,3.059c2.341,3.512-3.512,11.705-11.705,18.725S3.719,32.318,1.375,28.806,4.887,17.1,13.08,10.083,31.808-.451,34.149,3.059Z",
    transform: "translate(9.206 17.715)",
    fill: "#e6d87c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1693",
    "data-name": "Path 1693",
    d: "M34.149,3.059c2.341,3.512-3.512,11.705-11.705,18.725S3.719,32.318,1.375,28.806,4.887,17.1,13.08,10.083,31.808-.451,34.149,3.059Z",
    transform: "translate(9.206 17.715)",
    fill: "#e7dc7b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1694",
    "data-name": "Path 1694",
    d: "M34.149,3.059c2.341,3.512-3.512,11.705-11.705,18.725S3.719,32.318,1.375,28.806,4.887,17.1,13.08,10.083,31.808-.451,34.149,3.059Z",
    transform: "translate(9.206 17.715)",
    fill: "#e7dc7b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1695",
    "data-name": "Path 1695",
    d: "M32.768,3.059c2.341,3.512-3.512,11.705-11.705,18.725s-18.725,9.364-19.9,7.022,3.509-11.7,11.7-18.723S30.424-.451,32.768,3.059Z",
    transform: "translate(10.59 17.715)",
    fill: "#e7db79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1696",
    "data-name": "Path 1696",
    d: "M32.768,3.059c2.341,3.512-3.512,11.705-11.705,18.725s-18.725,9.364-19.9,7.022,3.509-11.7,11.7-18.723S30.424-.451,32.768,3.059Z",
    transform: "translate(10.59 17.715)",
    fill: "#e7db79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1697",
    "data-name": "Path 1697",
    d: "M33.078,3.275C35.419,6.787,29.566,14.98,21.373,22s-17.557,9.367-19.9,5.856S4.988,16.15,13.181,9.131,30.737-.236,33.078,3.275Z",
    transform: "translate(10.276 17.501)",
    fill: "#e9dc76",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1698",
    "data-name": "Path 1698",
    d: "M33.078,3.275C35.419,6.787,29.566,14.98,21.373,22s-17.557,9.367-19.9,5.856S4.988,16.15,13.181,9.131,30.737-.236,33.078,3.275Z",
    transform: "translate(10.276 17.501)",
    fill: "#e9dc76",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1699",
    "data-name": "Path 1699",
    d: "M33.078,4.127c2.341,3.512-3.512,11.705-11.705,18.725s-17.557,8.2-19.9,4.685S4.988,15.832,13.181,8.812,30.737-.554,33.078,4.127Z",
    transform: "translate(10.276 17.819)",
    fill: "#e9dc74",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1700",
    "data-name": "Path 1700",
    d: "M33.078,4.127c2.341,3.512-3.512,11.705-11.705,18.725s-17.557,8.2-19.9,4.685S4.988,15.832,13.181,8.812,30.737-.554,33.078,4.127Z",
    transform: "translate(10.276 17.819)",
    fill: "#e9dc74",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1701",
    "data-name": "Path 1701",
    d: "M33.078,3.653c2.341,3.512-3.512,11.705-11.705,18.725s-17.557,8.2-19.9,4.69S4.988,15.362,13.181,8.343,30.737.141,33.078,3.653Z",
    transform: "translate(10.276 18.293)",
    fill: "#eadc72",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1702",
    "data-name": "Path 1702",
    d: "M33.078,3.653c2.341,3.512-3.512,11.705-11.705,18.725s-17.557,8.2-19.9,4.69S4.988,15.362,13.181,8.343,30.737.141,33.078,3.653Z",
    transform: "translate(10.276 18.293)",
    fill: "#eadc70",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1703",
    "data-name": "Path 1703",
    d: "M31.907,3.653C34.249,7.165,28.4,15.358,20.2,22.378s-16.386,8.2-18.726,4.69S4.988,15.362,13.181,8.343,30.737.141,31.907,3.653Z",
    transform: "translate(10.276 18.293)",
    fill: "#ecdd6d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1704",
    "data-name": "Path 1704",
    d: "M31.907,3.653C34.249,7.165,28.4,15.358,20.2,22.378s-16.386,8.2-18.726,4.69S4.988,15.362,13.181,8.343,30.737.141,31.907,3.653Z",
    transform: "translate(10.276 18.293)",
    fill: "#ecdd6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1705",
    "data-name": "Path 1705",
    d: "M31.978,3.181c2.341,3.512-2.341,11.705-11.705,18.725S3.887,30.1,1.545,26.591,3.887,14.886,13.251,9.034,30.807-.33,31.978,3.181Z",
    transform: "translate(10.207 18.764)",
    fill: "#edde69",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1706",
    "data-name": "Path 1706",
    d: "M31.907,3.181C34.249,6.693,28.4,14.886,20.2,21.905S3.816,30.1,1.476,26.591,4.987,14.886,13.18,9.034,30.737-.33,31.907,3.181Z",
    transform: "translate(10.276 18.764)",
    fill: "#edde67",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1707",
    "data-name": "Path 1707",
    d: "M31.907,3.181C34.249,6.693,28.4,14.886,20.2,21.905S3.816,30.1,1.476,26.591,4.987,14.886,13.18,9.034,29.567-.33,31.907,3.181Z",
    transform: "translate(10.276 18.764)",
    fill: "#efe164",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1708",
    "data-name": "Path 1708",
    d: "M31.978,3.181c2.341,3.512-3.512,11.705-11.705,17.557S3.887,30.1,1.545,26.591,3.887,14.886,13.251,9.034,29.637-.33,31.978,3.181Z",
    transform: "translate(10.207 18.764)",
    fill: "#efe164",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1709",
    "data-name": "Path 1709",
    d: "M31.907,3.181C34.249,6.693,28.4,14.886,20.2,20.738S3.816,30.1,1.476,26.591,4.987,14.886,13.18,9.034,29.567-.33,31.907,3.181Z",
    transform: "translate(10.276 18.764)",
    fill: "#efdf61",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1710",
    "data-name": "Path 1710",
    d: "M31.907,3.181C34.249,6.693,28.4,14.886,20.2,20.738S3.816,30.1,1.476,26.591,4.987,14.886,13.18,9.034,29.567-.33,31.907,3.181Z",
    transform: "translate(10.276 18.764)",
    fill: "#f2e15f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1711",
    "data-name": "Path 1711",
    d: "M31.978,3.181c2.341,3.512-3.512,11.705-11.705,17.557S3.887,30.1,1.545,26.591,3.887,14.886,13.251,9.034,29.637-.33,31.978,3.181Z",
    transform: "translate(10.207 18.764)",
    fill: "#efe05f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1712",
    "data-name": "Path 1712",
    d: "M31.907,3.181C34.249,6.693,28.4,14.886,20.2,20.738S3.816,30.1,1.476,26.591,4.987,14.886,13.18,9.034,29.567-.33,31.907,3.181Z",
    transform: "translate(10.276 18.764)",
    fill: "#f0e057",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1713",
    "data-name": "Path 1713",
    d: "M31.978,3.181c2.341,3.512-2.341,11.705-11.705,17.557S3.887,30.1,1.545,26.591,3.887,14.886,13.251,9.034,29.637-.33,31.978,3.181Z",
    transform: "translate(10.207 18.764)",
    fill: "#f2e157",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1714",
    "data-name": "Path 1714",
    d: "M31.978,3.181c2.341,3.512-3.512,11.705-11.705,17.557S3.887,30.1,1.545,26.591,3.887,14.886,13.251,9.034,29.637-.33,31.978,3.181Z",
    transform: "translate(10.207 18.764)",
    fill: "#f2e14e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1715",
    "data-name": "Path 1715",
    d: "M31.907,3.181C34.249,6.693,28.4,14.886,20.2,20.738S3.816,30.1,1.476,26.591,4.987,14.886,13.18,9.034,29.567-.33,31.907,3.181Z",
    transform: "translate(10.276 18.764)",
    fill: "#f2e14b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1716",
    "data-name": "Path 1716",
    d: "M31.978,3.181c2.341,3.512-2.341,11.705-11.705,17.557S3.887,30.1,1.545,26.591,3.887,14.886,13.251,9.034,29.637-.33,31.978,3.181Z",
    transform: "translate(10.207 18.764)",
    fill: "#f2e045",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1717",
    "data-name": "Path 1717",
    d: "M31.907,3.375C34.249,6.887,28.4,15.08,20.2,20.932S3.816,30.3,1.476,26.781s3.511-10.53,11.7-17.553S29.567-.136,31.907,3.375Z",
    transform: "translate(10.276 18.57)",
    fill: "#f3e242",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1718",
    "data-name": "Path 1718",
    d: "M31.978,3.375c2.341,3.512-2.341,11.705-11.705,17.557S3.887,30.3,1.545,26.781,3.887,16.251,13.251,9.228,29.637-.136,31.978,3.375Z",
    transform: "translate(10.207 18.57)",
    fill: "#f3e239",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1719",
    "data-name": "Path 1719",
    d: "M31.978,3.375c2.341,3.512-2.341,10.534-11.705,17.557S3.887,30.3,1.545,26.781,3.887,16.251,13.251,9.228,29.637-.136,31.978,3.375Z",
    transform: "translate(10.207 18.57)",
    fill: "#f3e02f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1720",
    "data-name": "Path 1720",
    d: "M31.978,3.375c2.341,3.512-3.512,10.534-11.705,17.557S3.887,29.126,1.545,26.781,3.887,16.251,13.251,9.228,29.637-.136,31.978,3.375Z",
    transform: "translate(10.207 18.57)",
    fill: "#f3e21d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1721",
    "data-name": "Path 1721",
    d: "M31.907,3.375C34.249,6.887,29.566,13.909,20.2,20.932S3.816,29.126,1.476,26.781s3.511-10.53,11.7-17.553S29.567-.136,31.907,3.375Z",
    transform: "translate(10.276 18.57)",
    fill: "#f4e317",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1722",
    "data-name": "Path 1722",
    d: "M31.907,3.375C34.249,6.887,29.566,13.909,20.2,20.932S3.816,29.126,1.476,26.781s3.511-10.53,11.7-17.553S29.567-.136,31.907,3.375Z",
    transform: "translate(10.276 18.57)",
    fill: "#f4e317",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1723",
    "data-name": "Path 1723",
    d: "M31.907,3.375C34.249,6.887,28.4,13.909,20.2,20.932S3.816,29.126,1.476,26.781s3.511-10.53,11.7-17.553S29.567-.136,31.907,3.375Z",
    transform: "translate(10.276 18.57)",
    fill: "#f4e317",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    "data-name": "Path 1724",
    d: "M30.561,3.181C32.9,6.693,28.22,13.715,20.027,20.738S2.47,28.931,1.3,26.589s2.339-11.7,10.532-17.555S28.221-.33,30.561,3.181Z",
    transform: "translate(11.622 18.764)",
    fill: "#f8e313",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1725",
    "data-name": "Path 1725",
    d: "M30.561,2.72C32.9,6.23,28.221,13.255,20.027,20.277S2.47,28.47,1.3,26.129s2.339-11.7,10.532-17.557S28.221.379,30.561,2.72Z",
    transform: "translate(11.622 19.226)",
    fill: "#f8e313",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1726",
    "data-name": "Path 1726",
    d: "M29.393,2.72c2.34,3.509-2.348,10.534-10.532,17.557S2.471,28.47,1.3,26.131,3.642,14.425,11.835,8.572,28.222.379,29.393,2.72Z",
    transform: "translate(11.622 19.226)",
    fill: "#f8e313",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1727",
    "data-name": "Path 1727",
    d: "M29.393,2.72c2.34,3.509-2.348,10.534-10.532,17.557S2.471,28.47,1.3,26.131,3.642,14.425,11.835,8.572,28.222.379,29.393,2.72Z",
    transform: "translate(11.622 19.226)",
    fill: "#f8e313",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1728",
    "data-name": "Path 1728",
    d: "M18.861,20.277c-8.2,5.853-16.39,8.193-17.561,5.853S3.642,14.425,11.835,8.572,28.222.379,29.393,2.72,27.045,13.255,18.861,20.277Z",
    transform: "translate(11.622 19.226)",
    fill: "#f8e313",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1729",
    "data-name": "Path 1729",
    d: "M18.861,20.277c-8.2,5.853-16.39,8.193-17.561,4.677S3.642,14.425,11.835,8.572,28.222.379,29.393,2.72,27.045,13.255,18.861,20.277Z",
    transform: "translate(11.622 19.226)",
    fill: "#f8e313",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1730",
    "data-name": "Path 1730",
    d: "M18.861,20.277c-8.2,5.853-16.39,8.193-17.561,4.677S3.642,14.425,11.835,8.572,28.222.379,29.393,2.72,27.045,13.255,18.861,20.277Z",
    transform: "translate(11.622 19.226)",
    fill: "#f8e313",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1731",
    "data-name": "Path 1731",
    d: "M18.861,20.277c-8.2,5.853-16.39,8.193-17.561,4.677S3.642,14.425,11.835,8.572,28.222.379,29.393,2.72,27.045,13.255,18.861,20.277Z",
    transform: "translate(11.622 19.226)",
    fill: "#f8e313",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1732",
    "data-name": "Path 1732",
    d: "M18.861,19.9c-8.2,5.852-16.39,8.193-17.561,4.681S3.642,14.042,11.835,8.191,28.222,0,29.393,3.509,27.045,12.873,18.861,19.9Z",
    transform: "translate(11.622 19.608)",
    fill: "#f8e30c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1733",
    "data-name": "Path 1733",
    d: "M19.208,19.9c-8.193,5.852-15.216,8.193-17.557,4.681S3.992,14.042,12.186,8.191,28.572,0,29.742,3.509,27.4,12.873,19.208,19.9Z",
    transform: "translate(11.272 19.608)",
    fill: "#f8e30c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1734",
    "data-name": "Path 1734",
    d: "M19.208,19.9c-8.193,5.852-15.216,8.193-17.557,4.681S3.992,14.042,12.186,8.191,28.572,0,29.742,3.509,27.4,12.873,19.208,19.9Z",
    transform: "translate(11.272 19.608)",
    fill: "#f8e30c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    d: "M19.208,19.9c-8.193,5.852-15.216,8.193-17.557,4.681S3.992,14.042,12.186,8.191,28.572,0,29.742,3.509,27.4,12.873,19.208,19.9Z",
    transform: "translate(11.272 19.608)",
    fill: "#f8e30c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1736",
    "data-name": "Path 1736",
    d: "M19.208,19.9c-8.193,5.852-15.216,8.193-17.557,4.681S3.992,14.042,12.186,8.191,27.4,0,29.742,3.509,27.4,12.873,19.208,19.9Z",
    transform: "translate(11.272 19.608)",
    fill: "#f8e30c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1737",
    "data-name": "Path 1737",
    d: "M19.208,19.9c-8.193,5.852-15.216,8.193-17.557,4.681S3.992,14.042,12.186,8.191,27.4,0,29.742,3.509,27.4,12.873,19.208,19.9Z",
    transform: "translate(11.272 19.608)",
    fill: "#f8e527",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M19.208,19.9c-8.193,5.852-15.216,8.193-17.557,4.681S3.992,14.042,12.186,8.191,27.4,0,29.742,3.509,27.4,12.873,19.208,19.9Z",
    transform: "translate(11.272 19.608)",
    fill: "#f8e527",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M19.208,19.9c-8.193,5.852-15.216,8.193-17.557,4.681S3.992,14.042,12.186,8.191,27.4,0,29.742,3.509,27.4,12.873,19.208,19.9Z",
    transform: "translate(11.272 19.608)",
    fill: "#f8e63d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    d: "M19.136,19.9c-8.193,5.852-15.216,8.193-17.557,4.681S5.091,14.042,12.114,8.191,27.332,0,29.671,3.509,27.332,12.873,19.136,19.9Z",
    transform: "translate(11.344 19.608)",
    fill: "#f7e647",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1741",
    "data-name": "Path 1741",
    d: "M19.136,19.9c-8.193,5.852-15.216,8.193-17.557,4.681S5.091,14.042,12.114,8.191,27.332,0,29.671,3.509,27.332,12.873,19.136,19.9Z",
    transform: "translate(11.344 19.608)",
    fill: "#f7e64d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    d: "M19.136,19.9c-8.193,5.852-15.216,8.193-17.557,4.681S5.091,14.042,12.114,8.191,27.332,0,29.671,3.509,27.332,12.873,19.136,19.9Z",
    transform: "translate(11.344 19.608)",
    fill: "#f7e64d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1743",
    "data-name": "Path 1743",
    d: "M19.136,18.725c-8.193,7.022-15.216,9.364-17.557,5.852S5.091,14.042,12.114,8.191,27.332,0,29.671,3.509,26.16,12.873,19.136,18.725Z",
    transform: "translate(11.344 19.608)",
    fill: "#f7e653",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1744",
    "data-name": "Path 1744",
    d: "M19.136,18.725c-8.193,7.022-15.216,9.364-17.557,5.852S5.091,14.042,12.114,8.191,27.332,0,29.671,3.509,26.16,12.873,19.136,18.725Z",
    transform: "translate(11.344 19.608)",
    fill: "#f7e656",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1745",
    "data-name": "Path 1745",
    d: "M19.136,18.725c-8.193,5.852-15.216,9.364-17.557,5.852S5.091,14.042,12.114,8.191,27.332,0,29.671,3.509,26.16,12.873,19.136,18.725Z",
    transform: "translate(11.344 19.608)",
    fill: "#f7e656",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1746",
    "data-name": "Path 1746",
    d: "M19.136,18.725c-8.193,5.852-15.216,8.193-17.557,5.852S5.091,14.042,12.114,8.191,27.332,0,29.671,3.509,26.16,12.873,19.136,18.725Z",
    transform: "translate(11.344 19.608)",
    fill: "#f7e659",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1747",
    "data-name": "Path 1747",
    d: "M19.136,18.725c-8.193,5.852-15.216,8.193-17.557,5.852S5.091,14.042,12.114,8.191,27.332,0,29.671,3.509,26.16,12.873,19.136,18.725Z",
    transform: "translate(11.344 19.608)",
    fill: "#f7e659",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    "data-name": "Path 1748",
    d: "M19.136,18.725c-8.193,5.852-15.216,8.193-17.557,5.852S5.091,14.042,12.114,8.191,27.332,0,29.671,3.509,26.16,12.873,19.136,18.725Z",
    transform: "translate(11.344 19.608)",
    fill: "#f9ea5e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1749",
    "data-name": "Path 1749",
    d: "M19.136,18.725c-7.022,5.852-15.216,8.193-17.557,5.852S5.091,14.042,12.114,8.191,27.332,0,29.671,3.509,26.16,12.873,19.136,18.725Z",
    transform: "translate(11.344 19.608)",
    fill: "#f9ea61",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1750",
    "data-name": "Path 1750",
    d: "M19.136,18.25C12.114,24.1,3.921,26.449,1.579,24.1S5.091,13.568,12.114,7.716,27.332.693,29.671,3.033,26.16,12.4,19.136,18.25Z",
    transform: "translate(11.344 20.083)",
    fill: "#f9ea61",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1751",
    "data-name": "Path 1751",
    d: "M17.789,18.25C10.767,24.1,2.574,26.449,1.4,24.1S3.744,13.568,10.767,7.716,25.982.693,28.324,3.033,24.812,12.4,17.789,18.25Z",
    transform: "translate(12.691 20.083)",
    fill: "#f9ea66",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1752",
    "data-name": "Path 1752",
    d: "M17.789,18.25C10.767,24.1,2.574,26.449,1.4,24.1S3.744,13.568,10.767,7.716,25.982.693,28.324,3.033,24.812,12.4,17.789,18.25Z",
    transform: "translate(12.691 20.083)",
    fill: "#f9ea66",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1753",
    "data-name": "Path 1753",
    d: "M17.789,18.25C10.767,24.1,2.574,26.449,1.4,24.1S3.744,13.568,10.767,7.716,25.982.693,28.324,3.033,24.812,12.4,17.789,18.25Z",
    transform: "translate(12.691 20.083)",
    fill: "#f9e866",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    "data-name": "Path 1754",
    d: "M17.789,17.9C10.767,23.749,2.574,26.091,1.4,23.749S3.744,13.215,10.767,8.534,25.982.341,28.324,2.682,24.812,12.046,17.789,17.9Z",
    transform: "translate(12.691 20.435)",
    fill: "#f9e866",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    d: "M17.789,17.9C10.767,23.749,2.574,26.091,1.4,23.749S3.744,13.215,10.767,8.534,25.982.341,28.324,2.682,24.812,12.046,17.789,17.9Z",
    transform: "translate(12.691 20.435)",
    fill: "#f9e86b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M17.789,17.9C10.767,23.749,2.574,26.091,1.4,23.749S3.744,13.215,10.767,8.534,25.982.341,27.153,2.682,24.812,12.046,17.789,17.9Z",
    transform: "translate(12.691 20.435)",
    fill: "#f9e86b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M17.789,18.25C10.767,24.1,2.574,26.449,1.4,24.1S3.744,13.568,10.767,7.716,25.982.693,27.153,3.033,24.812,12.4,17.789,18.25Z",
    transform: "translate(12.691 20.083)",
    fill: "#f9e86d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    d: "M17.789,18.25C10.767,24.1,2.574,26.449,1.4,24.1S3.744,13.568,10.767,7.716,25.982.693,27.153,3.033,24.812,12.4,17.789,18.25Z",
    transform: "translate(12.691 20.083)",
    fill: "#f8e670",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    d: "M17.789,17.9C10.767,23.749,2.574,26.091,1.4,23.749S3.744,13.215,10.767,8.534,25.982.341,27.153,2.682,24.812,12.046,17.789,17.9Z",
    transform: "translate(12.691 20.435)",
    fill: "#f8e670",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    d: "M17.789,17.9C10.767,23.749,2.574,26.091,1.4,23.749S3.744,13.215,10.767,8.534,25.982.341,27.153,2.682,24.812,12.046,17.789,17.9Z",
    transform: "translate(12.691 20.435)",
    fill: "#f8e772",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    d: "M17.789,17.9C10.767,23.749,2.574,26.091,1.4,23.749S3.744,13.215,10.767,8.534,25.982.341,27.153,2.682,24.812,12.046,17.789,17.9Z",
    transform: "translate(12.691 20.435)",
    fill: "#f8e772",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    d: "M18.142,17.9C11.121,23.749,4.1,26.091,1.757,23.749S4.1,13.215,11.121,8.534,26.336.341,27.507,2.682,25.167,12.046,18.142,17.9Z",
    transform: "translate(12.337 20.435)",
    fill: "#fbec77",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M18.142,17.9C11.121,23.749,4.1,26.091,1.757,23.749S4.1,13.215,11.121,8.534,26.336.341,27.507,2.682,25.167,12.046,18.142,17.9Z",
    transform: "translate(12.337 20.435)",
    fill: "#fbec77",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    d: "M18.142,17.9C11.121,23.749,4.1,26.091,1.757,23.749S4.1,13.215,11.121,8.534,26.336.341,27.507,2.682,25.167,12.046,18.142,17.9Z",
    transform: "translate(12.337 20.435)",
    fill: "#f8e977",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    d: "M18.142,17.9C11.121,23.749,4.1,26.091,1.757,23.749S4.1,13.215,11.121,8.534,26.336.341,27.507,2.682,25.167,12.046,18.142,17.9Z",
    transform: "translate(12.337 20.435)",
    fill: "#f8e977",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    d: "M18.142,17.9C11.121,23.749,4.1,26.091,1.757,22.579S4.1,13.215,11.121,8.534,26.336.341,27.507,2.682,25.167,12.046,18.142,17.9Z",
    transform: "translate(12.337 20.435)",
    fill: "#f8e979",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1767",
    "data-name": "Path 1767",
    d: "M18.142,17.9C11.121,23.749,4.1,26.091,1.757,22.579S4.1,13.215,11.121,8.534,25.167.341,27.507,2.682,25.167,12.046,18.142,17.9Z",
    transform: "translate(12.337 20.435)",
    fill: "#f8e979",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1768",
    "data-name": "Path 1768",
    d: "M18.142,17.9C11.121,23.749,4.1,26.091,1.757,22.579S4.1,13.215,11.121,8.534,25.167.341,27.507,2.682,25.167,12.046,18.142,17.9Z",
    transform: "translate(12.337 20.435)",
    fill: "#f8e77b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1769",
    "data-name": "Path 1769",
    d: "M18.142,17.9C11.121,23.749,4.1,26.091,1.757,22.579S4.1,13.215,11.121,8.534,25.167.341,27.507,2.682,25.167,12.046,18.142,17.9Z",
    transform: "translate(12.337 20.435)",
    fill: "#f8e77b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1770",
    "data-name": "Path 1770",
    d: "M18.142,17.9C11.121,23.749,4.1,26.091,1.757,22.579S4.1,13.215,11.121,8.534,25.167.341,27.507,2.682,25.167,12.046,18.142,17.9Z",
    transform: "translate(12.337 20.435)",
    fill: "#f8e77b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1771",
    "data-name": "Path 1771",
    d: "M18.142,16.985C11.121,22.838,4.1,25.178,1.757,21.667S4.1,12.3,11.121,7.621,25.167.6,26.336,2.94,25.167,11.133,18.142,16.985Z",
    transform: "translate(12.337 21.348)",
    fill: "#fbec80",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1772",
    "data-name": "Path 1772",
    d: "M18.142,16.985C11.121,22.838,4.1,25.178,1.757,21.667S4.1,12.3,11.121,7.621,25.167.6,26.336,2.94,25.167,11.133,18.142,16.985Z",
    transform: "translate(12.337 21.348)",
    fill: "#fbec80",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1773",
    "data-name": "Path 1773",
    d: "M18.07,16.985c-7.022,5.853-14.045,8.193-16.386,4.683S5.2,12.3,11.047,7.621,25.092.6,26.263,2.94,25.092,11.133,18.07,16.985Z",
    transform: "translate(12.41 21.348)",
    fill: "#fbec84",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1774",
    "data-name": "Path 1774",
    d: "M18.07,16.985c-7.022,5.853-14.045,8.193-16.386,4.683S5.2,12.3,11.047,7.621,25.092.6,26.263,2.94,25.092,11.133,18.07,16.985Z",
    transform: "translate(12.41 21.348)",
    fill: "#fbec84",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    d: "M18.07,16.985c-7.022,5.853-14.045,8.193-16.386,4.683S5.2,12.3,11.047,7.621,25.092.6,26.263,2.94,25.092,11.133,18.07,16.985Z",
    transform: "translate(12.41 21.348)",
    fill: "#fbec84",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1776",
    "data-name": "Path 1776",
    d: "M18.07,16.985c-7.022,5.853-14.045,7.022-16.386,4.683S5.2,12.3,11.047,7.621,25.092.6,26.263,2.94,25.092,11.133,18.07,16.985Z",
    transform: "translate(12.41 21.348)",
    fill: "#faed88",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1777",
    "data-name": "Path 1777",
    d: "M18.07,16.985c-7.022,5.853-14.045,7.022-16.386,4.683S5.2,12.3,11.047,7.621,25.092.6,26.263,2.94,25.092,11.133,18.07,16.985Z",
    transform: "translate(12.41 21.348)",
    fill: "#faed88",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    d: "M18.07,16.985c-7.022,5.853-14.045,7.022-16.386,4.683S5.2,12.3,11.047,7.621,25.092.6,26.263,2.94,23.923,11.133,18.07,16.985Z",
    transform: "translate(12.41 21.348)",
    fill: "#faed88",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1779",
    "data-name": "Path 1779",
    d: "M16.721,16.985C9.7,22.838,2.675,24.007,1.505,21.667S3.845,12.3,9.7,7.621,23.744.6,24.914,2.94,23.744,11.133,16.721,16.985Z",
    transform: "translate(13.759 21.348)",
    fill: "#faed88",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1780",
    "data-name": "Path 1780",
    d: "M16.721,16.985C9.7,22.838,2.675,24.007,1.505,21.667S3.845,12.3,9.7,7.621,23.744.6,24.914,2.94,23.744,11.133,16.721,16.985Z",
    transform: "translate(13.759 21.348)",
    fill: "#fdee8a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1781",
    "data-name": "Path 1781",
    d: "M16.721,16.985C9.7,22.838,2.675,24.007,1.505,21.667S3.845,12.3,9.7,7.621,23.744.6,24.914,2.94,22.573,11.133,16.721,16.985Z",
    transform: "translate(13.759 21.348)",
    fill: "#fdee8a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1782",
    "data-name": "Path 1782",
    d: "M16.721,16.985C9.7,21.667,2.675,24.007,1.505,21.667S3.845,12.3,9.7,7.621,23.744.6,24.914,2.94,22.573,11.133,16.721,16.985Z",
    transform: "translate(13.759 21.348)",
    fill: "#fdee8c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1783",
    "data-name": "Path 1783",
    d: "M16.721,16.985C9.7,21.667,2.675,24.007,1.505,21.667S3.845,12.3,9.7,7.621,22.573.6,24.914,2.94,22.573,11.133,16.721,16.985Z",
    transform: "translate(13.759 21.348)",
    fill: "#fdee8c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1784",
    "data-name": "Path 1784",
    d: "M16.721,16.985C9.7,21.667,2.675,24.007,1.505,21.667S3.845,12.3,9.7,7.621,22.573.6,24.914,2.94,22.573,11.133,16.721,16.985Z",
    transform: "translate(13.759 21.348)",
    fill: "#fdee8c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1785",
    "data-name": "Path 1785",
    d: "M16.718,16.985C9.7,21.667,2.672,24.007,1.5,21.667S3.844,12.3,10.867,7.621,23.742.6,26.082,2.94,22.572,11.133,16.718,16.985Z",
    transform: "translate(13.762 21.348)",
    fill: "#fdee8c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1786",
    "data-name": "Path 1786",
    d: "M16.718,16.985C9.7,21.667,2.672,24.007,1.5,21.667S3.844,12.3,10.867,7.621,23.742.6,26.082,2.94,22.572,11.133,16.718,16.985Z",
    transform: "translate(13.762 21.348)",
    fill: "#fdee8c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1787",
    "data-name": "Path 1787",
    d: "M16.718,16.985C9.7,21.667,2.672,24.007,1.5,21.667S3.844,12.3,10.867,7.621,23.742.6,26.082,2.94,22.572,11.133,16.718,16.985Z",
    transform: "translate(13.762 21.348)",
    fill: "#faed90",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    d: "M16.718,16.985C9.7,21.667,2.672,24.007,1.5,21.667S3.844,12.3,10.867,7.621,23.742.6,26.082,2.94,22.572,11.133,16.718,16.985Z",
    transform: "translate(13.762 21.348)",
    fill: "#fff292",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1789",
    "data-name": "Path 1789",
    d: "M16.718,16.985C9.7,21.667,2.672,24.007,1.5,21.667S3.844,12.3,10.867,7.621,23.742.6,26.082,2.94,22.572,11.133,16.718,16.985Z",
    transform: "translate(13.762 21.348)",
    fill: "#fff292",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1790",
    "data-name": "Path 1790",
    d: "M16.718,16.985C9.7,21.667,2.672,24.007,1.5,21.667S3.844,12.3,10.867,7.621,23.742.6,26.082,2.94,22.572,11.133,16.718,16.985Z",
    transform: "translate(13.762 21.348)",
    fill: "#fff294",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1791",
    "data-name": "Path 1791",
    d: "M16.718,17.18C9.7,21.861,2.674,24.2,1.5,21.861s2.341-8.193,9.364-14.045S23.742.793,26.082,3.133,22.572,11.328,16.718,17.18Z",
    transform: "translate(13.762 21.153)",
    fill: "#fff294",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1792",
    "data-name": "Path 1792",
    d: "M16.718,17.18C9.7,21.861,2.674,24.2,1.5,21.861s2.341-8.193,9.364-14.045S23.742.793,24.913,3.133,22.572,11.328,16.718,17.18Z",
    transform: "translate(13.762 21.153)",
    fill: "#fff296",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    d: "M16.718,17.18C9.7,21.861,2.674,24.2,1.5,21.861s2.341-8.193,9.364-14.045S23.742.793,24.913,3.133,22.572,11.328,16.718,17.18Z",
    transform: "translate(13.762 21.153)",
    fill: "#fff296",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    d: "M16.718,17.18C9.7,21.861,2.674,24.2,1.5,21.861s2.341-8.193,9.364-14.045S23.742.793,24.913,3.133,22.572,11.328,16.718,17.18Z",
    transform: "translate(13.762 21.153)",
    fill: "#fff296",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    d: "M15.55,17.18C9.7,21.861,2.675,24.2,1.505,21.861S3.845,13.668,9.7,7.816,22.574.793,23.745,3.133,22.573,11.328,15.55,17.18Z",
    transform: "translate(13.759 21.153)",
    fill: "#fdee96",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    d: "M15.9,17.18C10.05,21.861,4.2,24.2,1.857,21.861S4.2,13.668,11.221,7.816,24.1.793,25.267,3.133,22.926,12.5,15.9,17.18Z",
    transform: "translate(13.407 21.153)",
    fill: "#fdee96",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1797",
    "data-name": "Path 1797",
    d: "M15.909,17.18C10.059,21.861,4.2,24.2,1.863,21.861s2.341-8.193,8.2-14.045S22.934.793,24.105,3.133,22.932,12.5,15.909,17.18Z",
    transform: "translate(13.4 21.153)",
    fill: "#fcef98",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1798",
    "data-name": "Path 1798",
    d: "M15.909,15.914C10.059,20.6,4.2,22.938,1.863,20.6S4.2,12.4,10.059,7.721,22.932.7,24.1,3.04,22.932,11.233,15.909,15.914Z",
    transform: "translate(13.4 22.419)",
    fill: "#fcef98",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1799",
    "data-name": "Path 1799",
    d: "M15.909,15.914C10.059,20.6,4.2,22.938,1.863,20.6S4.2,12.4,10.059,7.721,22.932.7,24.1,3.04,22.932,11.233,15.909,15.914Z",
    transform: "translate(13.4 22.419)",
    fill: "#fcef98",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1800",
    "data-name": "Path 1800",
    d: "M15.909,15.914C10.059,20.6,4.2,22.938,1.863,20.6S4.2,12.4,10.059,7.721,22.932.7,24.1,3.04,22.932,11.233,15.909,15.914Z",
    transform: "translate(13.4 22.419)",
    fill: "#fcef98",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    d: "M15.909,16.985C10.059,21.667,4.2,22.838,1.863,20.5S4.2,12.3,10.059,7.621,22.932.6,24.1,2.94,22.932,12.3,15.909,16.985Z",
    transform: "translate(13.4 21.348)",
    fill: "#fcef98",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1802",
    "data-name": "Path 1802",
    d: "M15.909,16.985C10.059,21.667,4.2,22.838,1.863,20.5S4.2,12.3,10.059,7.621,22.932.6,24.1,2.94,22.932,12.3,15.909,16.985Z",
    transform: "translate(13.4 21.348)",
    fill: "#fced99",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1803",
    "data-name": "Path 1803",
    d: "M15.909,16.985C10.059,21.667,4.2,22.838,1.863,20.5S4.2,12.3,10.059,7.621,22.932.6,24.1,2.94,22.932,12.3,15.909,16.985Z",
    transform: "translate(13.4 21.348)",
    fill: "#fff09d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1804",
    "data-name": "Path 1804",
    d: "M15.909,16.985C10.059,21.667,4.2,22.838,1.863,20.5S4.2,12.3,10.059,7.621,22.932.6,24.1,2.94,22.932,12.3,15.909,16.985Z",
    transform: "translate(13.4 21.348)",
    fill: "#faee9a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1805",
    "data-name": "Path 1805",
    d: "M15.909,16.146C10.059,20.824,4.2,22,1.863,19.657s2.341-8.193,8.2-12.874S22.934.93,25.274,3.27,22.932,11.464,15.909,16.146Z",
    transform: "translate(13.4 22.187)",
    fill: "#faee9a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1806",
    "data-name": "Path 1806",
    d: "M14.48,16.146C8.628,20.824,2.775,22,1.605,19.657S3.945,11.464,9.8,6.782,21.5.93,23.845,3.27,21.5,11.464,14.48,16.146Z",
    transform: "translate(14.83 22.187)",
    fill: "#f9ee9e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    d: "M14.48,16.985C8.628,21.667,2.775,22.836,1.6,20.5S3.946,12.3,9.8,7.621,21.5.6,23.844,2.94,21.5,12.3,14.48,16.985Z",
    transform: "translate(14.829 21.348)",
    fill: "#f9ee9e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1808",
    "data-name": "Path 1808",
    d: "M14.48,16.985C8.628,21.667,2.775,22.836,1.6,20.5S3.946,12.3,9.8,7.621,21.5.6,23.844,2.94,21.5,12.3,14.48,16.985Z",
    transform: "translate(14.829 21.348)",
    fill: "#f9ee9e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1809",
    "data-name": "Path 1809",
    d: "M14.48,16.985C8.628,21.667,2.775,22.836,1.6,20.5S3.946,12.3,9.8,7.621,21.5.6,23.844,2.94,21.5,12.3,14.48,16.985Z",
    transform: "translate(14.829 21.348)",
    fill: "#f9eea0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1810",
    "data-name": "Path 1810",
    d: "M14.48,16.985C8.628,21.667,2.775,22.836,1.6,20.5S3.946,12.3,9.8,7.621,21.5.6,23.844,2.94,21.5,12.3,14.48,16.985Z",
    transform: "translate(14.829 21.348)",
    fill: "#f9eea0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1811",
    "data-name": "Path 1811",
    d: "M14.48,16.985C8.628,21.667,2.775,22.836,1.6,20.5S3.946,12.3,9.8,7.621,21.5.6,23.844,2.94,21.5,12.3,14.48,16.985Z",
    transform: "translate(14.829 21.348)",
    fill: "#fff3a2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1812",
    "data-name": "Path 1812",
    d: "M14.48,16.985C8.628,21.667,2.775,22.836,1.6,20.5S3.946,12.3,9.8,7.621,21.5.6,23.844,2.94,20.333,12.3,14.48,16.985Z",
    transform: "translate(14.829 21.348)",
    fill: "#fff3a2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1813",
    "data-name": "Path 1813",
    d: "M14.48,15.814C8.628,21.666,2.775,22.836,1.6,20.5S3.946,12.3,9.8,7.621,21.5.6,23.844,2.94,20.333,12.3,14.48,15.814Z",
    transform: "translate(14.829 21.348)",
    fill: "#fff3a2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1814",
    "data-name": "Path 1814",
    d: "M14.48,14.975C8.628,20.824,2.775,22,1.605,19.657S3.945,11.464,9.8,6.782,21.5.93,23.845,3.27,20.333,11.464,14.48,14.975Z",
    transform: "translate(14.83 22.187)",
    fill: "#fcf2a4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1815",
    "data-name": "Path 1815",
    d: "M14.48,14.975C8.628,19.658,2.775,22,1.6,19.658S3.946,11.464,9.8,6.782,21.5.93,23.845,3.27,20.333,11.464,14.48,14.975Z",
    transform: "translate(14.829 22.187)",
    fill: "#fcf2a4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1816",
    "data-name": "Path 1816",
    d: "M14.48,14.975C8.628,19.658,2.775,22,1.6,19.658S3.946,11.464,9.8,6.782,21.5.93,23.845,3.27,20.333,11.464,14.48,14.975Z",
    transform: "translate(14.829 22.187)",
    fill: "#fff3a6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1817",
    "data-name": "Path 1817",
    d: "M14.48,14.975C8.628,19.658,2.775,22,1.6,19.658S3.946,11.464,9.8,6.782,21.5.93,22.675,3.27,20.333,11.464,14.48,14.975Z",
    transform: "translate(14.829 22.187)",
    fill: "#fff3a6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1818",
    "data-name": "Path 1818",
    d: "M14.48,14.975C8.628,19.658,2.775,22,1.6,19.658S3.946,11.464,9.8,6.782,21.5.93,22.675,3.27,20.333,11.464,14.48,14.975Z",
    transform: "translate(14.829 22.187)",
    fill: "#fff3a6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1819",
    "data-name": "Path 1819",
    d: "M14.48,13.7C8.628,18.379,2.775,20.719,1.6,18.379S3.946,10.184,9.8,6.672,21.5.821,22.673,3.163,20.333,10.184,14.48,13.7Z",
    transform: "translate(14.829 23.466)",
    fill: "#f9eea3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1820",
    "data-name": "Path 1820",
    d: "M14.48,13.7C8.628,18.379,2.775,20.719,1.6,18.379S3.946,10.184,9.8,6.672,21.5.821,22.673,3.163,20.333,10.184,14.48,13.7Z",
    transform: "translate(14.829 23.466)",
    fill: "#f9eea3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1821",
    "data-name": "Path 1821",
    d: "M14.48,13.7C8.628,18.379,2.775,20.719,1.6,18.379S3.946,10.184,9.8,6.672,21.5.821,22.673,3.163,20.333,10.184,14.48,13.7Z",
    transform: "translate(14.829 23.466)",
    fill: "#fff1a7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1822",
    "data-name": "Path 1822",
    d: "M14.48,14.6C8.628,19.285,2.775,21.621,1.605,19.285s2.34-8.2,8.193-11.711S21.5.552,22.673,2.894,20.333,11.087,14.48,14.6Z",
    transform: "translate(14.83 22.565)",
    fill: "#fff1ab",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1823",
    "data-name": "Path 1823",
    d: "M14.48,14.6C8.628,19.285,2.775,21.621,1.605,19.285s2.34-8.2,8.193-11.711S21.5.552,22.673,2.894,20.333,11.087,14.48,14.6Z",
    transform: "translate(14.83 22.565)",
    fill: "#fff1ab",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1824",
    "data-name": "Path 1824",
    d: "M14.48,13.7C8.628,18.379,2.775,20.719,1.6,18.379S3.946,10.184,9.8,6.672,21.5.821,22.673,3.163,20.333,10.184,14.48,13.7Z",
    transform: "translate(14.829 23.466)",
    fill: "#fff1ab",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    d: "M14.48,13.7C8.628,18.379,2.775,20.719,1.6,18.379S3.946,10.184,9.8,6.672,21.5.821,22.673,3.163,20.333,10.184,14.48,13.7Z",
    transform: "translate(14.829 23.466)",
    fill: "#fff1ab",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    d: "M14.48,13.9c-5.852,4.681-11.705,7.02-12.874,4.681s2.34-7.022,8.193-11.7S21.5,1.03,22.674,3.37,20.333,10.393,14.48,13.9Z",
    transform: "translate(14.83 23.257)",
    fill: "#fff1ab",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1827",
    "data-name": "Path 1827",
    d: "M14.48,13.9c-5.852,4.681-11.705,7.02-12.874,4.681s2.34-7.022,8.193-11.7S21.5,1.03,22.674,3.37,20.333,10.393,14.48,13.9Z",
    transform: "translate(14.83 23.257)",
    fill: "#fcf0ab",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1828",
    "data-name": "Path 1828",
    d: "M14.483,13.9C8.63,18.586,2.778,20.924,1.607,18.586s2.341-7.022,7.022-11.7S20.335,1.03,21.505,3.37,20.335,10.393,14.483,13.9Z",
    transform: "translate(14.826 23.257)",
    fill: "#fcf0ab",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1829",
    "data-name": "Path 1829",
    d: "M14.48,13.9c-5.852,4.681-11.705,7.02-12.874,4.681s2.34-7.022,8.193-11.7S21.5,1.03,22.674,3.37,20.333,10.393,14.48,13.9Z",
    transform: "translate(14.83 23.257)",
    fill: "#fcf0ab",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1830",
    "data-name": "Path 1830",
    d: "M14.483,13.9C8.63,18.586,2.778,20.924,1.607,18.586s2.341-7.022,7.022-11.7S20.335,1.03,21.505,3.37,20.335,10.393,14.483,13.9Z",
    transform: "translate(14.826 23.257)",
    fill: "#fff4b0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1831",
    "data-name": "Path 1831",
    d: "M14.483,13.9C8.63,18.586,2.778,20.924,1.607,18.586s2.341-7.022,7.022-11.7S20.335,1.03,21.505,3.37,20.335,10.393,14.483,13.9Z",
    transform: "translate(14.826 23.257)",
    fill: "#fff4b0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1832",
    "data-name": "Path 1832",
    d: "M14.842,14.743C8.99,19.429,4.308,20.6,1.973,19.429S4.308,12.4,8.99,7.721,20.7.7,23.036,3.04,20.7,11.233,14.842,14.743Z",
    transform: "translate(14.467 22.419)",
    fill: "#fff4b2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1833",
    "data-name": "Path 1833",
    d: "M13.412,14.976C7.561,19.657,2.878,20.825,1.707,18.486s2.341-7.022,7.022-11.7S19.261.929,21.605,3.271,19.261,11.464,13.412,14.976Z",
    transform: "translate(15.897 22.187)",
    fill: "#fff4b2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1834",
    "data-name": "Path 1834",
    d: "M13.412,14.976C7.561,19.657,2.878,20.825,1.707,18.486s2.341-7.022,7.022-11.7S19.261.929,21.605,3.271,19.261,11.464,13.412,14.976Z",
    transform: "translate(15.897 22.187)",
    fill: "#fff4b2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1835",
    "data-name": "Path 1835",
    d: "M13.412,14.976C7.561,19.657,2.878,20.825,1.707,18.486s2.341-7.022,7.022-11.7S19.261.929,21.605,3.271,19.261,11.464,13.412,14.976Z",
    transform: "translate(15.897 22.187)",
    fill: "#fef2b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1836",
    "data-name": "Path 1836",
    d: "M13.412,14.976C7.561,19.657,2.878,20.825,1.707,18.486s2.341-7.022,7.022-11.7S19.261.929,20.435,3.271,19.261,11.464,13.412,14.976Z",
    transform: "translate(15.897 22.187)",
    fill: "#fef2b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1837",
    "data-name": "Path 1837",
    d: "M13.412,14.976C7.561,19.657,2.878,20.825,1.707,18.486s2.341-7.022,7.022-11.7S19.261.929,20.435,3.271,19.261,11.464,13.412,14.976Z",
    transform: "translate(15.897 22.187)",
    fill: "#fef2b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    d: "M13.412,14.976C7.561,19.657,2.878,20.825,1.707,18.486s2.341-7.022,7.022-11.7S19.261.929,20.435,3.271,19.261,11.464,13.412,14.976Z",
    transform: "translate(15.897 22.187)",
    fill: "#fef2b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1839",
    "data-name": "Path 1839",
    d: "M13.412,14.976C7.561,18.486,2.878,20.825,1.707,18.486s2.341-7.022,7.022-11.7S19.261.929,20.435,3.271,19.261,11.464,13.412,14.976Z",
    transform: "translate(15.897 22.187)",
    fill: "#fef2b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    d: "M13.412,14.976C7.561,18.486,2.878,20.825,1.707,18.486s2.341-7.022,7.022-11.7S19.261.929,20.435,3.271,19.261,11.464,13.412,14.976Z",
    transform: "translate(15.897 22.187)",
    fill: "#fff8b8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    d: "M13.412,14.976C7.561,19.657,2.878,20.825,1.707,18.486s2.341-7.022,7.022-11.7S19.261.929,20.435,3.271,19.261,11.464,13.412,14.976Z",
    transform: "translate(15.897 22.187)",
    fill: "#fff8b8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    d: "M13.412,14.976C7.561,18.486,2.878,20.825,1.707,18.486s2.341-7.022,7.022-11.7S19.261.929,20.435,3.271,19.261,11.464,13.412,14.976Z",
    transform: "translate(15.897 22.187)",
    fill: "#fff8ba",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    d: "M13.412,14.976C7.561,18.486,2.878,20.825,1.707,18.486s2.341-7.022,7.022-11.7S19.261.929,20.435,3.271,19.261,11.464,13.412,14.976Z",
    transform: "translate(15.897 22.187)",
    fill: "#fff8ba",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1844",
    "data-name": "Path 1844",
    d: "M13.412,14.976C7.561,18.486,2.878,20.825,1.707,18.486s2.341-7.022,7.022-11.7S19.261.929,20.435,3.271,19.261,11.464,13.412,14.976Z",
    transform: "translate(15.897 22.187)",
    fill: "#fff8ba",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1845",
    "data-name": "Path 1845",
    d: "M13.412,13.7C7.561,17.208,2.878,19.548,1.707,17.208S4.049,10.184,8.73,6.672,19.261.821,20.435,3.163,19.261,10.184,13.412,13.7Z",
    transform: "translate(15.897 23.466)",
    fill: "#fff8bc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1846",
    "data-name": "Path 1846",
    d: "M13.412,13.7C7.561,17.208,2.878,19.548,1.707,17.208S4.049,10.184,8.73,6.672,19.261.821,20.435,3.163,19.261,10.184,13.412,13.7Z",
    transform: "translate(15.897 23.466)",
    fill: "#fff8bc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1847",
    "data-name": "Path 1847",
    d: "M13.412,13.7C7.561,17.208,2.878,19.548,1.707,17.208S4.049,10.184,8.73,6.672,19.261.821,20.435,3.163,19.261,10.184,13.412,13.7Z",
    transform: "translate(15.897 23.466)",
    fill: "#fff8bc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    d: "M13.412,13.7C8.73,17.208,2.878,19.548,1.707,17.208S4.049,10.184,8.73,6.672,19.261.821,20.435,3.163,19.261,10.184,13.412,13.7Z",
    transform: "translate(15.897 23.466)",
    fill: "#fbf1b9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    d: "M13.412,13.7C8.73,17.208,2.878,19.548,1.707,17.208S4.049,10.184,8.73,6.672,19.261.821,20.435,3.163,19.261,10.184,13.412,13.7Z",
    transform: "translate(15.897 23.466)",
    fill: "#fbf1b9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    d: "M13.412,13.7C8.73,17.208,2.878,19.548,1.707,17.208S4.049,10.184,8.73,6.672,19.261.821,20.435,3.163,18.094,10.184,13.412,13.7Z",
    transform: "translate(15.897 23.466)",
    fill: "#fef2bb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    d: "M13.412,13.7C8.73,17.208,2.878,19.548,1.707,17.208S4.049,10.184,8.73,6.672,19.261.821,20.435,3.163,18.094,10.184,13.412,13.7Z",
    transform: "translate(15.897 23.466)",
    fill: "#fef2bb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1852",
    "data-name": "Path 1852",
    d: "M13.473,13.7C8.79,17.208,2.938,19.548,1.768,17.208S2.938,10.184,8.79,6.672,19.325.821,20.5,3.163,18.154,10.184,13.473,13.7Z",
    transform: "translate(15.837 23.466)",
    fill: "#fef2bb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    d: "M13.412,13.7C8.73,17.208,2.878,19.548,1.707,17.208S4.049,10.184,8.73,6.672,19.261.821,20.435,3.163,18.094,10.184,13.412,13.7Z",
    transform: "translate(15.897 23.466)",
    fill: "#fef5be",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    d: "M13.412,13.7C8.73,17.208,2.878,19.548,1.707,17.208S4.049,10.184,8.73,6.672,19.261.821,20.435,3.163,18.094,10.184,13.412,13.7Z",
    transform: "translate(15.897 23.466)",
    fill: "#fef5be",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    "data-name": "Path 1855",
    d: "M13.473,13.7C8.79,17.208,2.938,19.548,1.768,17.208S2.938,10.184,8.79,6.672,19.325.821,20.5,3.163,18.154,10.184,13.473,13.7Z",
    transform: "translate(15.837 23.466)",
    fill: "#fef5be",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    d: "M13.473,13.7C8.79,17.208,2.938,19.548,1.768,17.208S2.938,10.184,8.79,6.672,18.154.821,20.5,3.163,18.154,10.184,13.473,13.7Z",
    transform: "translate(15.837 23.466)",
    fill: "#fef2bd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    d: "M13.412,13.7C8.73,17.208,2.878,19.548,1.707,17.208S4.049,10.184,8.73,6.672,18.094.821,20.435,3.163,18.094,10.184,13.412,13.7Z",
    transform: "translate(15.897 23.466)",
    fill: "#fef2bd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1858",
    "data-name": "Path 1858",
    d: "M13.473,13.7C8.79,17.208,2.938,19.548,1.768,17.208S2.938,10.184,8.79,6.672,18.154.821,20.5,3.163,18.154,10.184,13.473,13.7Z",
    transform: "translate(15.837 23.466)",
    fill: "#fef2bd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1859",
    "data-name": "Path 1859",
    d: "M13.473,13.7C8.79,17.208,2.938,19.548,1.768,17.208S2.938,10.184,8.79,6.672,18.154.821,20.5,3.163,18.154,10.184,13.473,13.7Z",
    transform: "translate(15.837 23.466)",
    fill: "#fef2bd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    "data-name": "Path 1860",
    d: "M13.771,13.7c-4.681,3.511-9.364,5.852-11.7,3.511S4.408,10.184,9.09,6.672,19.625.821,20.8,3.163,18.454,10.184,13.771,13.7Z",
    transform: "translate(15.538 23.466)",
    fill: "#fbf1bd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    "data-name": "Path 1861",
    d: "M12.4,13.9c-4.683,3.511-9.364,4.681-10.534,3.511S3.038,11.564,8.89,6.882s9.364-5.853,10.534-3.512S17.083,10.393,12.4,13.9Z",
    transform: "translate(16.907 23.257)",
    fill: "#fef3c1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    "data-name": "Path 1862",
    d: "M12.4,13.9c-4.683,3.511-9.364,4.681-10.534,3.511S3.038,11.564,8.89,6.882s9.364-5.853,10.534-3.512S17.083,10.393,12.4,13.9Z",
    transform: "translate(16.907 23.257)",
    fill: "#fef3c1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1863",
    "data-name": "Path 1863",
    d: "M12.4,13.429c-4.683,3.512-9.364,4.683-10.534,3.512S3.038,11.088,8.89,6.406s8.193-4.683,9.364-3.512S17.083,9.918,12.4,13.429Z",
    transform: "translate(16.907 23.733)",
    fill: "#fef3c1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1864",
    "data-name": "Path 1864",
    d: "M12.4,13.429c-4.683,3.512-9.364,4.683-10.534,3.512S3.038,11.088,8.89,6.406s8.193-4.683,9.364-3.512S17.083,9.918,12.4,13.429Z",
    transform: "translate(16.907 23.733)",
    fill: "#fef3c1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1865",
    "data-name": "Path 1865",
    d: "M12.4,13.429c-4.683,3.512-9.364,4.683-10.534,3.512S3.038,11.088,8.89,6.406s8.193-4.683,9.364-3.512S17.083,9.918,12.4,13.429Z",
    transform: "translate(16.907 23.733)",
    fill: "#fef3c1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    d: "M12.406,13.112c-4.681,3.512-9.364,4.683-10.533,3.512S3.042,10.771,7.725,7.26s9.364-5.852,10.529-4.681S17.089,9.6,12.406,13.112Z",
    transform: "translate(16.903 24.05)",
    fill: "#fff5c5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    d: "M12.406,13.112c-4.681,3.512-9.364,4.683-10.533,3.512S3.042,10.771,7.725,7.26s9.364-5.852,10.529-4.681S17.089,9.6,12.406,13.112Z",
    transform: "translate(16.903 24.05)",
    fill: "#fff5c5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    d: "M12.406,13.112c-4.681,3.512-9.364,4.683-10.533,3.512S3.042,10.771,7.725,7.26s9.364-5.852,10.529-4.681S17.089,9.6,12.406,13.112Z",
    transform: "translate(16.903 24.05)",
    fill: "#fff5c5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    d: "M12.406,13.112c-4.681,3.512-9.364,4.683-10.533,3.512S3.042,10.771,7.725,7.26s9.364-5.852,10.529-4.681S17.089,9.6,12.406,13.112Z",
    transform: "translate(16.903 24.05)",
    fill: "#fff5c5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1870",
    "data-name": "Path 1870",
    d: "M12.406,13.112c-4.681,3.512-9.364,4.683-10.533,3.512S3.042,10.771,7.725,7.26s9.364-5.852,10.529-4.681S17.089,9.6,12.406,13.112Z",
    transform: "translate(16.903 24.05)",
    fill: "#fff5c5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1871",
    "data-name": "Path 1871",
    d: "M12.406,13.112c-4.681,3.512-9.364,4.683-10.533,3.512S3.042,10.771,7.725,7.26s9.364-5.852,10.529-4.681S17.089,9.6,12.406,13.112Z",
    transform: "translate(16.903 24.05)",
    fill: "#fff5c5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1872",
    "data-name": "Path 1872",
    d: "M12.407,13.236c-4.683,3.512-9.364,4.683-10.534,2.341S3.043,9.725,7.724,6.213,17.089,1.531,18.254,2.7,17.089,9.724,12.407,13.236Z",
    transform: "translate(16.903 23.926)",
    fill: "#fff5c5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1873",
    "data-name": "Path 1873",
    d: "M12.407,13.236c-4.683,3.512-9.364,4.683-10.534,2.341S3.043,9.725,7.724,6.213,17.089,1.531,18.254,2.7,17.089,9.724,12.407,13.236Z",
    transform: "translate(16.903 23.926)",
    fill: "#fff5c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1874",
    "data-name": "Path 1874",
    d: "M12.406,12.878C7.725,16.39,3.042,17.559,1.873,15.219S3.044,9.367,7.725,5.855s9.364-4.683,10.529-2.341S17.089,9.366,12.406,12.878Z",
    transform: "translate(16.903 24.284)",
    fill: "#fff5c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1875",
    "data-name": "Path 1875",
    d: "M12.406,12.878C7.725,16.39,3.042,17.559,1.873,15.219S3.044,9.367,7.725,5.855s9.364-4.683,10.529-2.341S17.089,9.366,12.406,12.878Z",
    transform: "translate(16.903 24.284)",
    fill: "#fff5c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1876",
    "data-name": "Path 1876",
    d: "M12.406,12.878C7.725,16.39,3.042,17.559,1.873,15.219S3.044,9.367,7.725,5.855s9.364-4.683,10.529-2.341S17.089,9.366,12.406,12.878Z",
    transform: "translate(16.903 24.284)",
    fill: "#fff5c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1877",
    "data-name": "Path 1877",
    d: "M12.406,12.878C7.725,16.39,3.042,17.559,1.873,15.219S3.044,9.367,7.725,5.855s9.364-4.683,10.529-2.341S17.089,9.366,12.406,12.878Z",
    transform: "translate(16.903 24.284)",
    fill: "#fff5c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1878",
    "data-name": "Path 1878",
    d: "M12.406,12.878C7.725,16.39,3.042,17.559,1.873,15.219S3.044,9.367,7.725,5.855s9.364-4.683,10.529-2.341S17.089,9.366,12.406,12.878Z",
    transform: "translate(16.903 24.284)",
    fill: "#fff5c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1879",
    "data-name": "Path 1879",
    d: "M12.406,12.878C7.725,16.39,3.042,17.559,1.873,15.219S3.044,9.367,7.725,5.855s9.364-4.683,10.529-2.341S17.089,9.366,12.406,12.878Z",
    transform: "translate(16.903 24.284)",
    fill: "#fff5cb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1880",
    "data-name": "Path 1880",
    d: "M12.406,12.878C7.725,16.39,3.042,17.559,1.873,15.219S3.044,9.367,7.725,5.855s9.364-4.683,10.529-2.341S15.918,9.366,12.406,12.878Z",
    transform: "translate(16.903 24.284)",
    fill: "#fff5cb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    d: "M12.406,12.878C7.725,16.39,3.042,17.559,1.873,15.219S3.044,9.367,7.725,5.855s9.364-4.683,10.529-2.341S15.918,9.366,12.406,12.878Z",
    transform: "translate(16.903 24.284)",
    fill: "#fff5cb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    d: "M12.406,12.878c-4.681,2.341-9.364,4.681-10.533,2.341S3.044,9.367,7.725,5.855s9.364-4.683,10.529-2.341S15.918,9.366,12.406,12.878Z",
    transform: "translate(16.903 24.284)",
    fill: "#fff5cb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1883",
    "data-name": "Path 1883",
    d: "M12.406,12.878c-4.681,2.341-9.364,4.681-10.533,2.341S3.044,9.367,7.725,5.855s9.364-4.683,10.529-2.341S15.918,9.366,12.406,12.878Z",
    transform: "translate(16.903 24.284)",
    fill: "#fff5cb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1884",
    "data-name": "Path 1884",
    d: "M12.406,12.878c-4.681,2.341-9.364,4.681-10.533,2.341S3.044,9.367,7.725,5.855s9.364-4.683,10.529-2.341S15.918,9.366,12.406,12.878Z",
    transform: "translate(16.903 24.284)",
    fill: "#fff5cb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1885",
    "data-name": "Path 1885",
    d: "M11.064,12.878C6.383,15.219,1.7,17.559,1.7,15.219S2.871,9.367,7.552,5.855s8.193-4.683,9.364-2.341S14.576,9.366,11.064,12.878Z",
    transform: "translate(18.246 24.284)",
    fill: "#fffbd2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    d: "M11.064,12.878C6.383,15.219,1.7,17.559,1.7,15.219S2.871,9.367,7.552,5.855s8.193-4.683,9.364-2.341S14.576,9.366,11.064,12.878Z",
    transform: "translate(18.246 24.284)",
    fill: "#fffbd2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1887",
    "data-name": "Path 1887",
    d: "M11.064,12.878C6.383,15.219,1.7,16.39,1.7,15.219A14.131,14.131,0,0,1,7.552,5.855c4.683-3.512,8.195-4.683,9.364-2.341S14.576,9.366,11.064,12.878Z",
    transform: "translate(18.246 24.284)",
    fill: "#fffbd2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1888",
    "data-name": "Path 1888",
    d: "M11.337,12.878c-4.683,2.341-8.193,3.512-9.364,2.341S3.144,9.367,7.825,5.855s8.193-4.683,9.364-2.341S14.848,9.366,11.337,12.878Z",
    transform: "translate(17.974 24.284)",
    fill: "#fffbd2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1889",
    "data-name": "Path 1889",
    d: "M11.337,12.878c-4.683,2.341-8.193,3.512-9.364,2.341S3.144,9.367,7.825,5.855s8.193-4.683,9.364-2.341S14.848,9.366,11.337,12.878Z",
    transform: "translate(17.974 24.284)",
    fill: "#fffbd2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1890",
    "data-name": "Path 1890",
    d: "M11.337,11.707c-4.683,3.512-8.193,4.683-9.364,3.512S3.144,9.367,7.825,5.855s8.193-4.683,9.364-2.341S14.848,9.366,11.337,11.707Z",
    transform: "translate(17.974 24.284)",
    fill: "#fffbd2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1891",
    "data-name": "Path 1891",
    d: "M11.337,11.234c-4.683,3.512-8.193,4.683-9.364,3.512S3.144,8.894,7.825,5.382s8.193-3.513,9.364-2.341S14.848,8.892,11.337,11.234Z",
    transform: "translate(17.974 24.758)",
    fill: "#fffbd3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1892",
    "data-name": "Path 1892",
    d: "M11.337,11.234c-4.683,3.512-8.193,4.683-9.364,3.512S3.144,8.894,7.825,5.382s8.193-3.513,9.364-2.341S14.848,8.892,11.337,11.234Z",
    transform: "translate(17.974 24.758)",
    fill: "#fffbd3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1893",
    "data-name": "Path 1893",
    d: "M11.337,10.412c-4.683,3.512-8.193,4.683-9.364,3.512s1.169-5.853,5.852-8.2,8.193-4.683,9.364-2.341S14.848,8.071,11.337,10.412Z",
    transform: "translate(17.974 25.581)",
    fill: "#fffbd3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1894",
    "data-name": "Path 1894",
    d: "M11.337,10.412c-4.683,3.512-8.193,4.683-9.364,3.512s1.169-5.853,5.852-8.2,8.193-4.683,9.364-2.341S14.848,8.071,11.337,10.412Z",
    transform: "translate(17.974 25.581)",
    fill: "#fff8d4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1895",
    "data-name": "Path 1895",
    d: "M11.337,10.412c-4.683,3.512-8.193,4.683-9.364,3.512s1.169-5.853,5.852-8.2,8.193-4.683,9.364-2.341S14.848,8.071,11.337,10.412Z",
    transform: "translate(17.974 25.581)",
    fill: "#fff8d4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1896",
    "data-name": "Path 1896",
    d: "M11.337,10.412c-4.683,3.512-8.193,4.683-9.364,3.512s1.169-5.853,5.852-8.2,8.193-4.683,9.364-2.341S14.848,8.071,11.337,10.412Z",
    transform: "translate(17.974 25.581)",
    fill: "#fff8d4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1897",
    "data-name": "Path 1897",
    d: "M11.337,10.412c-4.683,3.512-8.193,4.683-9.364,3.512s1.169-5.853,5.852-8.2,8.193-4.683,9.364-2.341S14.848,8.071,11.337,10.412Z",
    transform: "translate(17.974 25.581)",
    fill: "#fff6d2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1898",
    "data-name": "Path 1898",
    d: "M11.337,10.412c-4.683,3.512-8.193,4.683-9.364,3.512s1.169-5.853,5.852-8.2,8.193-4.683,9.364-2.341S14.848,8.071,11.337,10.412Z",
    transform: "translate(17.974 25.581)",
    fill: "#fff6d2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1899",
    "data-name": "Path 1899",
    d: "M11.337,10.412c-4.683,3.512-8.193,4.683-9.364,3.512s1.169-5.853,5.852-8.2,8.193-4.683,9.364-2.341S14.848,8.071,11.337,10.412Z",
    transform: "translate(17.974 25.581)",
    fill: "#fff6d2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1900",
    "data-name": "Path 1900",
    d: "M11.337,10.636c-4.683,3.512-8.193,4.683-9.364,3.512S3.144,9.466,7.825,5.955s8.193-4.683,9.364-2.341S14.848,8.3,11.337,10.636Z",
    transform: "translate(17.974 25.355)",
    fill: "#fff6d4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1901",
    "data-name": "Path 1901",
    d: "M11.337,10.636c-4.683,3.512-8.193,4.683-9.364,3.512S3.144,9.466,7.825,5.955s8.193-4.683,9.364-2.341S14.848,8.3,11.337,10.636Z",
    transform: "translate(17.974 25.355)",
    fill: "#fff6d4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1902",
    "data-name": "Path 1902",
    d: "M11.337,10.636c-4.683,3.512-8.193,4.683-9.364,3.512S3.144,9.466,7.825,5.955s8.193-4.683,9.364-2.341S14.848,8.3,11.337,10.636Z",
    transform: "translate(17.974 25.355)",
    fill: "#fff6d4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1903",
    "data-name": "Path 1903",
    d: "M11.337,10.636c-4.683,3.512-8.193,4.683-9.364,3.512S3.144,9.466,7.825,5.955s8.193-4.683,9.364-2.341S14.848,8.3,11.337,10.636Z",
    transform: "translate(17.974 25.355)",
    fill: "#fff8d7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1904",
    "data-name": "Path 1904",
    d: "M11.343,11.707C6.66,15.219,3.15,16.389,1.979,14.048S3.15,9.366,6.662,5.855s8.193-4.683,8.193-2.341S14.853,9.366,11.343,11.707Z",
    transform: "translate(17.968 24.285)",
    fill: "#fff8d7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1905",
    "data-name": "Path 1905",
    d: "M11.343,11.234C6.66,14.745,3.15,15.916,1.979,13.575S3.15,8.892,6.662,5.382s8.192-3.513,8.192-2.341S14.853,8.892,11.343,11.234Z",
    transform: "translate(17.968 24.758)",
    fill: "#fff8d7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1906",
    "data-name": "Path 1906",
    d: "M11.337,11.234c-4.683,3.512-8.195,4.683-9.364,2.341S3.144,8.892,7.825,5.382s8.193-3.513,8.193-2.341a11.956,11.956,0,0,1-4.681,8.193Z",
    transform: "translate(17.974 24.758)",
    fill: "#fff8d7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1907",
    "data-name": "Path 1907",
    d: "M11.343,11.234C6.66,14.745,3.15,15.916,1.979,13.575S3.15,8.892,6.662,5.382s7.021-3.513,8.192-2.341S14.853,8.892,11.343,11.234Z",
    transform: "translate(17.968 24.758)",
    fill: "#fff9dd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1908",
    "data-name": "Path 1908",
    d: "M11.343,11.234C6.66,14.745,3.15,15.916,1.979,13.575S3.15,8.892,6.662,5.382s7.021-3.513,8.192-2.341S14.853,8.892,11.343,11.234Z",
    transform: "translate(17.968 24.758)",
    fill: "#fff9dd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1909",
    "data-name": "Path 1909",
    d: "M11.343,11.234C6.66,14.745,3.15,15.916,1.979,13.575S3.15,8.892,6.662,5.382s7.021-3.513,8.192-2.341S14.853,8.892,11.343,11.234Z",
    transform: "translate(17.968 24.758)",
    fill: "#fff9dd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1910",
    "data-name": "Path 1910",
    d: "M11.343,11.234C6.66,14.745,3.15,15.916,1.979,13.575S3.15,8.892,6.662,5.382s7.021-3.513,8.192-2.341S14.853,8.892,11.343,11.234Z",
    transform: "translate(17.968 24.758)",
    fill: "#fff9dd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1911",
    "data-name": "Path 1911",
    d: "M11.343,11.234C6.66,14.745,3.15,15.916,1.979,13.575S3.15,8.892,6.662,5.382s7.021-3.513,8.192-2.341S14.853,8.892,11.343,11.234Z",
    transform: "translate(17.968 24.758)",
    fill: "#fff9dd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1912",
    "data-name": "Path 1912",
    d: "M11.343,11.234C6.66,14.745,3.15,14.745,1.979,13.575S3.15,8.892,6.662,5.382s7.021-3.513,8.192-2.341S14.853,8.892,11.343,11.234Z",
    transform: "translate(17.968 24.758)",
    fill: "#fff9dd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1913",
    "data-name": "Path 1913",
    d: "M9.993,11.234C5.312,13.575,1.8,14.745,1.8,13.575S2.971,8.892,6.483,5.382s7.022-3.513,8.193-2.341S13.505,8.892,9.993,11.234Z",
    transform: "translate(19.316 24.758)",
    fill: "#fdfbdf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1914",
    "data-name": "Path 1914",
    d: "M9.993,11.234C5.312,13.575,1.8,14.745,1.8,13.575S2.971,8.892,6.483,5.382s7.022-3.513,8.193-2.341S13.505,8.892,9.993,11.234Z",
    transform: "translate(19.316 24.758)",
    fill: "#fdfbdf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1915",
    "data-name": "Path 1915",
    d: "M9.993,9.943C5.312,12.284,1.8,13.455,1.8,12.284A10.231,10.231,0,0,1,6.483,5.261C9.995,2.92,13.505,1.749,14.676,2.92S13.505,7.6,9.993,9.943Z",
    transform: "translate(19.316 26.049)",
    fill: "#fdfbdf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1916",
    "data-name": "Path 1916",
    d: "M9.993,9.943C5.312,12.284,1.8,13.455,1.8,12.284A10.231,10.231,0,0,1,6.483,5.261C9.995,2.92,13.505,1.749,14.676,2.92S13.505,7.6,9.993,9.943Z",
    transform: "translate(19.316 26.049)",
    fill: "#fdfbdf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1917",
    "data-name": "Path 1917",
    d: "M9.993,9.943C5.312,12.284,1.8,13.455,1.8,12.284A10.231,10.231,0,0,1,6.483,5.261C9.995,2.92,13.505,1.749,14.676,2.92S13.505,7.6,9.993,9.943Z",
    transform: "translate(19.316 26.049)",
    fill: "#fffde3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1918",
    "data-name": "Path 1918",
    d: "M8.822,9.943C5.312,12.284,1.8,13.455,1.8,12.284A10.231,10.231,0,0,1,6.483,5.261C9.995,2.92,13.505,1.749,14.676,2.92S12.334,7.6,8.822,9.943Z",
    transform: "translate(19.316 26.049)",
    fill: "#fffde3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1919",
    "data-name": "Path 1919",
    d: "M8.822,9.943C6.483,12.284,1.8,13.455,1.8,12.284A10.231,10.231,0,0,1,6.483,5.261C9.995,2.92,13.505,1.749,14.676,2.92S12.334,7.6,8.822,9.943Z",
    transform: "translate(19.316 26.049)",
    fill: "#fffde3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1920",
    "data-name": "Path 1920",
    d: "M9.1,9.943c-2.341,2.341-5.853,3.512-7.022,2.341S3.248,7.6,6.76,5.261s7.022-3.512,8.193-2.341S12.612,7.6,9.1,9.943Z",
    transform: "translate(19.037 26.049)",
    fill: "#fffde5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1921",
    "data-name": "Path 1921",
    d: "M9.1,9.943c-2.341,2.341-5.853,3.512-7.022,2.341S3.248,7.6,6.76,5.261s7.022-3.512,8.193-2.341S12.612,7.6,9.1,9.943Z",
    transform: "translate(19.037 26.049)",
    fill: "#fffde5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1922",
    "data-name": "Path 1922",
    d: "M9.1,9.943c-2.341,2.341-5.853,3.512-7.022,2.341S3.248,7.6,6.76,5.261s7.022-3.512,8.193-2.341S12.612,7.6,9.1,9.943Z",
    transform: "translate(19.037 26.049)",
    fill: "#fffde5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1923",
    "data-name": "Path 1923",
    d: "M9.1,9.943c-2.341,2.341-5.853,3.512-7.022,2.341S3.248,7.6,6.76,5.261s7.022-3.512,8.193-2.341S12.612,7.6,9.1,9.943Z",
    transform: "translate(19.037 26.049)",
    fill: "#fffde3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1924",
    "data-name": "Path 1924",
    d: "M9.1,9.943c-2.341,2.341-5.853,3.512-7.022,2.341S3.248,7.6,6.76,5.261s7.022-3.512,7.022-2.341A10.231,10.231,0,0,1,9.1,9.943Z",
    transform: "translate(19.037 26.049)",
    fill: "#fffde3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1925",
    "data-name": "Path 1925",
    d: "M9.1,9.943c-2.341,2.341-5.853,3.512-7.022,2.341S3.248,7.6,6.76,5.261s7.022-3.512,7.022-2.341A10.231,10.231,0,0,1,9.1,9.943Z",
    transform: "translate(19.037 26.049)",
    fill: "#fffde3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1926",
    "data-name": "Path 1926",
    d: "M9.1,9.943c-2.341,2.341-5.853,3.512-7.022,2.341S3.248,7.6,6.76,5.261s7.022-3.512,7.022-2.341A10.231,10.231,0,0,1,9.1,9.943Z",
    transform: "translate(19.037 26.049)",
    fill: "#fffde3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1927",
    "data-name": "Path 1927",
    d: "M9.1,9.943c-2.341,2.341-5.853,3.512-7.022,2.341S3.248,7.6,6.76,5.261s7.022-3.512,7.022-2.341A10.231,10.231,0,0,1,9.1,9.943Z",
    transform: "translate(19.037 26.049)",
    fill: "#fff9e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1928",
    "data-name": "Path 1928",
    d: "M9.1,9.943c-2.341,2.341-5.853,3.512-7.022,2.341S3.248,7.6,6.76,5.261s7.022-3.512,7.022-2.341A10.231,10.231,0,0,1,9.1,9.943Z",
    transform: "translate(19.037 26.049)",
    fill: "#fff9e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1929",
    "data-name": "Path 1929",
    d: "M9.1,9.943c-2.341,2.341-5.853,3.512-7.022,2.341S3.248,7.6,6.76,5.261s5.852-3.512,7.022-2.341S12.612,7.6,9.1,9.943Z",
    transform: "translate(19.037 26.049)",
    fill: "#fff9e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1930",
    "data-name": "Path 1930",
    d: "M9.1,9.943c-2.341,2.341-5.853,3.512-7.022,2.341S3.248,7.6,6.76,5.261s5.852-3.512,7.022-2.341S12.612,7.6,9.1,9.943Z",
    transform: "translate(19.037 26.049)",
    fill: "#fffde9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1931",
    "data-name": "Path 1931",
    d: "M9.1,9.943c-2.341,2.341-5.853,3.512-7.022,2.341S3.248,7.6,6.76,5.261s5.852-3.512,7.022-2.341S12.612,7.6,9.1,9.943Z",
    transform: "translate(19.037 26.049)",
    fill: "#fffde9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1932",
    "data-name": "Path 1932",
    d: "M9.1,9.943c-2.341,2.341-5.853,3.512-7.022,2.341S3.248,7.6,6.76,5.261s5.852-3.512,7.022-2.341S12.612,7.6,9.1,9.943Z",
    transform: "translate(19.037 26.049)",
    fill: "#fffde9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1933",
    "data-name": "Path 1933",
    d: "M9.1,9.943c-2.341,2.341-5.853,3.512-7.022,2.341S3.248,7.6,6.76,5.261s5.852-3.512,7.022-2.341S12.612,7.6,9.1,9.943Z",
    transform: "translate(19.037 26.049)",
    fill: "#fffde9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1934",
    "data-name": "Path 1934",
    d: "M9.1,9.943c-2.341,2.341-5.853,3.512-7.022,2.341S3.248,7.6,6.76,5.261s5.852-3.512,7.022-2.341S12.612,7.6,9.1,9.943Z",
    transform: "translate(19.037 26.049)",
    fill: "#fcfcea",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1935",
    "data-name": "Path 1935",
    d: "M9.1,9.943c-2.341,2.341-5.853,3.512-7.022,2.341S3.248,7.6,6.76,5.261s5.852-3.512,7.022-2.341S12.612,7.6,9.1,9.943Z",
    transform: "translate(19.037 26.049)",
    fill: "#fcfcea",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1936",
    "data-name": "Path 1936",
    d: "M9.1,8.872c-2.341,2.343-5.853,3.512-7.022,2.343S3.248,7.7,6.76,5.361s5.852-3.512,7.022-2.341S12.612,6.531,9.1,8.872Z",
    transform: "translate(19.037 27.12)",
    fill: "#fcfcea",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1937",
    "data-name": "Path 1937",
    d: "M9.106,8.872c-2.341,2.343-5.852,3.512-7.02,2.343S3.255,7.7,5.594,5.361s5.853-3.512,7.024-2.341S12.618,6.531,9.106,8.872Z",
    transform: "translate(19.032 27.12)",
    fill: "#fffeee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1938",
    "data-name": "Path 1938",
    d: "M9.106,8.872c-2.341,2.343-5.852,3.512-7.02,2.343S3.255,7.7,5.594,5.361s5.853-3.512,7.024-2.341S12.618,6.531,9.106,8.872Z",
    transform: "translate(19.032 27.12)",
    fill: "#fffeee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1939",
    "data-name": "Path 1939",
    d: "M9.106,9.943c-2.341,2.341-5.852,2.341-7.02,1.172S3.255,7.6,5.594,5.261s5.853-3.512,7.024-2.341S12.618,7.6,9.106,9.943Z",
    transform: "translate(19.032 26.049)",
    fill: "#fffeee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1940",
    "data-name": "Path 1940",
    d: "M7.752,9.943C5.412,12.284,1.9,12.284,1.9,11.115S3.071,7.6,5.412,5.261s5.852-3.512,7.022-2.341S11.264,7.6,7.752,9.943Z",
    transform: "translate(20.387 26.049)",
    fill: "#fffeee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1941",
    "data-name": "Path 1941",
    d: "M7.752,9.943C5.412,12.284,1.9,12.284,1.9,11.115S3.071,7.6,5.412,5.261s5.852-3.512,7.022-2.341S11.264,7.6,7.752,9.943Z",
    transform: "translate(20.387 26.049)",
    fill: "#fffeee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1942",
    "data-name": "Path 1942",
    d: "M7.752,9.943C5.412,12.284,1.9,12.284,1.9,11.115S3.071,7.6,5.412,5.261s5.852-3.512,7.022-2.341S11.264,7.6,7.752,9.943Z",
    transform: "translate(20.387 26.049)",
    fill: "#fffeee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1943",
    "data-name": "Path 1943",
    d: "M7.752,9.943C5.412,12.284,1.9,12.284,1.9,11.115S3.071,7.6,5.412,5.261s5.852-3.512,7.022-2.341S11.264,7.6,7.752,9.943Z",
    transform: "translate(20.387 26.049)",
    fill: "#fffeee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1944",
    "data-name": "Path 1944",
    d: "M7.752,9.943C5.412,12.284,1.9,12.284,1.9,11.115S3.071,7.6,5.412,5.261s5.852-3.512,7.022-2.341S11.264,7.6,7.752,9.943Z",
    transform: "translate(20.387 26.049)",
    fill: "#fffeee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1945",
    "data-name": "Path 1945",
    d: "M7.752,9.943C5.412,12.284,1.9,12.284,1.9,11.115S3.071,7.6,5.412,5.261s5.852-3.512,5.852-2.341A7.906,7.906,0,0,1,7.752,9.943Z",
    transform: "translate(20.387 26.049)",
    fill: "#fffef2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1946",
    "data-name": "Path 1946",
    d: "M7.752,9.943C5.412,11.115,1.9,12.284,1.9,11.115S3.071,7.6,5.412,5.261s5.852-3.512,5.852-2.341A7.906,7.906,0,0,1,7.752,9.943Z",
    transform: "translate(20.387 26.049)",
    fill: "#fffef2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1947",
    "data-name": "Path 1947",
    d: "M7.752,9.943C5.412,11.115,1.9,12.284,1.9,11.115S3.071,7.6,5.412,5.261s5.852-3.512,5.852-2.341A7.906,7.906,0,0,1,7.752,9.943Z",
    transform: "translate(20.387 26.049)",
    fill: "#fffef2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1948",
    "data-name": "Path 1948",
    d: "M7.752,9.943C5.412,11.115,1.9,12.284,1.9,11.115S3.071,7.6,5.412,5.261s5.852-3.512,5.852-2.341A7.906,7.906,0,0,1,7.752,9.943Z",
    transform: "translate(20.387 26.049)",
    fill: "#fffef2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1949",
    "data-name": "Path 1949",
    d: "M7.752,9.522C5.412,10.693,1.9,11.864,1.9,10.693S3.071,7.181,5.412,4.841A9.14,9.14,0,0,1,11.264,2.5S11.264,7.183,7.752,9.522Z",
    transform: "translate(20.387 26.469)",
    fill: "#fffef2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1950",
    "data-name": "Path 1950",
    d: "M7.752,9.943C5.412,11.115,1.9,12.284,1.9,11.115S3.071,7.6,5.412,5.261s5.852-3.512,5.852-2.341A7.906,7.906,0,0,1,7.752,9.943Z",
    transform: "translate(20.387 26.049)",
    fill: "#fffef2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1951",
    "data-name": "Path 1951",
    d: "M7.752,9.943C5.412,11.115,1.9,12.284,1.9,11.115S3.071,7.6,5.412,5.261s5.852-3.512,5.852-2.341A7.906,7.906,0,0,1,7.752,9.943Z",
    transform: "translate(20.387 26.049)",
    fill: "#fffef2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1952",
    "data-name": "Path 1952",
    d: "M8.037,9.522C5.7,10.693,3.354,11.864,2.185,10.693S3.355,7.181,5.7,4.841A9.14,9.14,0,0,1,11.549,2.5S11.549,7.183,8.037,9.522Z",
    transform: "translate(20.102 26.469)",
    fill: "#fffaf0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1953",
    "data-name": "Path 1953",
    d: "M8.036,8.352c-2.341,2.341-4.681,3.512-5.849,2.341S3.357,7.181,5.7,4.841A9.14,9.14,0,0,1,11.548,2.5S10.37,7.183,8.036,8.352Z",
    transform: "translate(20.103 26.469)",
    fill: "#fffaf0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1954",
    "data-name": "Path 1954",
    d: "M8.036,8.352c-2.341,2.341-4.681,3.512-5.849,2.341S3.357,7.181,5.7,4.841A9.14,9.14,0,0,1,11.548,2.5S10.37,7.183,8.036,8.352Z",
    transform: "translate(20.103 26.469)",
    fill: "#fffaf0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1955",
    "data-name": "Path 1955",
    d: "M8.036,8.352c-2.341,2.341-4.681,3.512-5.849,2.341S3.357,7.181,5.7,4.841A9.14,9.14,0,0,1,11.548,2.5S10.37,7.183,8.036,8.352Z",
    transform: "translate(20.103 26.469)",
    fill: "#fffaf0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1956",
    "data-name": "Path 1956",
    d: "M8.036,8.352c-2.341,2.341-4.681,3.512-5.849,2.341S3.357,7.181,5.7,4.841A9.14,9.14,0,0,1,11.548,2.5S10.37,7.183,8.036,8.352Z",
    transform: "translate(20.103 26.469)",
    fill: "#fffaf0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1957",
    "data-name": "Path 1957",
    d: "M8.036,8.352c-2.341,2.341-4.681,3.512-5.849,2.341S3.357,7.181,5.7,4.841A9.14,9.14,0,0,1,11.548,2.5S10.37,7.183,8.036,8.352Z",
    transform: "translate(20.103 26.469)",
    fill: "#fffaf0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1958",
    "data-name": "Path 1958",
    d: "M8.036,8.354C5.694,10.7,3.354,11.866,2.187,10.7S3.357,7.184,5.7,4.844A7.565,7.565,0,0,1,11.548,2.5C12.718,2.5,10.37,7.185,8.036,8.354Z",
    transform: "translate(20.103 26.466)",
    fill: "#fffaf0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1959",
    "data-name": "Path 1959",
    d: "M8.036,8.354C5.694,10.7,3.354,11.866,2.187,10.7S3.357,7.184,5.7,4.844A7.565,7.565,0,0,1,11.548,2.5C12.718,2.5,10.37,7.185,8.036,8.354Z",
    transform: "translate(20.103 26.466)",
    fill: "#fffef4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1960",
    "data-name": "Path 1960",
    d: "M8.036,8.354A7.565,7.565,0,0,1,2.187,10.7C1.016,10.7,3.358,7.184,5.7,4.844A7.565,7.565,0,0,1,11.548,2.5C12.719,2.5,10.37,7.185,8.036,8.354Z",
    transform: "translate(20.103 26.466)",
    fill: "#fffef4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1961",
    "data-name": "Path 1961",
    d: "M8.036,8.354A7.565,7.565,0,0,1,2.187,10.7C1.016,10.7,3.358,7.184,5.7,4.844A7.565,7.565,0,0,1,11.548,2.5C12.719,2.5,10.37,7.185,8.036,8.354Z",
    transform: "translate(20.103 26.466)",
    fill: "#fffef4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1962",
    "data-name": "Path 1962",
    d: "M8.036,7.985a7.565,7.565,0,0,1-5.849,2.341c-1.171,0,1.171-3.512,3.512-5.852S10.37,2.133,11.548,3.3,10.37,6.814,8.036,7.985Z",
    transform: "translate(20.103 26.836)",
    fill: "#fffef4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1963",
    "data-name": "Path 1963",
    d: "M8.036,7.985a7.565,7.565,0,0,1-5.849,2.341c-1.171,0,1.171-3.512,3.512-5.852S10.37,2.133,11.548,3.3,10.37,6.814,8.036,7.985Z",
    transform: "translate(20.103 26.836)",
    fill: "#fffef4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1964",
    "data-name": "Path 1964",
    d: "M8.036,8.354C5.694,10.7,3.354,10.7,2.187,9.525S3.357,7.184,5.7,4.842A7.565,7.565,0,0,1,11.548,2.5C12.718,2.5,10.37,7.185,8.036,8.354Z",
    transform: "translate(20.103 26.466)",
    fill: "#fffef4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1965",
    "data-name": "Path 1965",
    d: "M8.036,8.354C5.694,10.7,3.354,10.7,2.187,9.525S3.357,7.184,5.7,4.842A7.565,7.565,0,0,1,11.548,2.5C12.718,2.5,10.37,7.185,8.036,8.354Z",
    transform: "translate(20.103 26.466)",
    fill: "#fffef4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1966",
    "data-name": "Path 1966",
    d: "M8.036,7.985c-2.341,2.341-4.681,2.341-5.849,1.171S3.355,6.814,5.694,4.473,10.37,2.133,11.548,3.3,10.37,6.814,8.036,7.985Z",
    transform: "translate(20.103 26.836)",
    fill: "#fffef4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1967",
    "data-name": "Path 1967",
    d: "M6.683,7.985A7.25,7.25,0,0,1,2,10.326,9.14,9.14,0,0,1,4.341,4.473C6.683,2.132,9.024,2.132,10.193,3.3S9.022,6.814,6.683,7.985Z",
    transform: "translate(21.458 26.836)",
    fill: "#fffef9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1968",
    "data-name": "Path 1968",
    d: "M6.683,7.985C4.341,10.326,2,10.326,2,9.156S2,6.814,4.341,4.473,9.024,2.132,10.193,3.3,9.022,6.814,6.683,7.985Z",
    transform: "translate(21.458 26.836)",
    fill: "#fffef9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1969",
    "data-name": "Path 1969",
    d: "M6.683,7.985C4.341,10.326,2,10.326,2,9.156S2,6.814,4.341,4.473,9.024,2.132,10.193,3.3,9.022,6.814,6.683,7.985Z",
    transform: "translate(21.458 26.836)",
    fill: "#fffef9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1970",
    "data-name": "Path 1970",
    d: "M6.683,7.985C4.341,10.326,2,10.326,2,9.156S2,6.814,4.341,4.473,9.024,2.132,9.024,3.3A4.673,4.673,0,0,1,6.683,7.985Z",
    transform: "translate(21.458 26.836)",
    fill: "#fffef9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1971",
    "data-name": "Path 1971",
    d: "M6.683,7.985C4.341,10.326,2,10.326,2,9.156S2,6.814,4.341,4.473,9.024,2.132,9.024,3.3A4.673,4.673,0,0,1,6.683,7.985Z",
    transform: "translate(21.458 26.836)",
    fill: "#fbfdf8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1972",
    "data-name": "Path 1972",
    d: "M6.683,7.985C4.341,10.326,2,10.326,2,9.156S2,6.814,4.341,4.473,9.024,2.132,9.024,3.3A4.673,4.673,0,0,1,6.683,7.985Z",
    transform: "translate(21.458 26.836)",
    fill: "#fbfdf8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1973",
    "data-name": "Path 1973",
    d: "M6.683,7.985C4.341,9.156,2,10.326,2,9.156S2,6.814,4.341,4.473,9.024,2.132,9.024,3.3A4.673,4.673,0,0,1,6.683,7.985Z",
    transform: "translate(21.458 26.836)",
    fill: "#fbfdf8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1974",
    "data-name": "Path 1974",
    d: "M6.683,7.985C4.341,9.156,2,10.326,2,9.156S2,6.814,4.341,4.473,9.024,2.132,9.024,3.3A4.673,4.673,0,0,1,6.683,7.985Z",
    transform: "translate(21.458 26.836)",
    fill: "#fbfdf8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1975",
    "data-name": "Path 1975",
    d: "M6.683,7.985C4.341,10.326,2,10.326,2,9.156S2,6.814,4.341,4.473,9.024,2.132,9.024,3.3A4.673,4.673,0,0,1,6.683,7.985Z",
    transform: "translate(21.458 26.836)",
    fill: "#fffffb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    d: "M6.683,7.985C4.341,9.156,2,10.326,2,9.156S2,6.814,4.341,4.473,9.024,2.132,9.024,3.3A4.673,4.673,0,0,1,6.683,7.985Z",
    transform: "translate(21.458 26.836)",
    fill: "#fffffb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    d: "M6.683,7.985C4.341,9.156,2,10.326,2,9.156S3.171,6.814,4.341,4.473,9.024,2.132,9.024,3.3A4.673,4.673,0,0,1,6.683,7.985Z",
    transform: "translate(21.458 26.836)",
    fill: "#fffffb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M6.683,7.985C4.341,9.156,2,10.326,2,9.156S3.171,6.814,4.341,4.473,9.024,2.132,9.024,3.3A4.673,4.673,0,0,1,6.683,7.985Z",
    transform: "translate(21.458 26.836)",
    fill: "#fffffb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M6.683,7.985C4.341,9.156,2,10.326,2,9.156S3.171,6.814,4.341,4.473,9.024,2.132,9.024,3.3A4.673,4.673,0,0,1,6.683,7.985Z",
    transform: "translate(21.458 26.836)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M6.683,7.982C4.341,9.153,2,10.323,2,9.153S3.171,6.811,4.341,4.47A2.9,2.9,0,0,1,9.024,3.3C10.193,4.47,9.022,6.811,6.683,7.982Z",
    transform: "translate(21.458 26.839)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M6.683,7.982C4.341,9.153,2,10.323,2,9.153S3.171,6.811,4.341,4.47A2.9,2.9,0,0,1,9.024,3.3C10.193,4.47,9.022,6.811,6.683,7.982Z",
    transform: "translate(21.458 26.839)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    d: "M6.683,7.982C4.341,9.153,2,10.323,2,9.153S3.171,6.811,4.341,4.47A2.9,2.9,0,0,1,9.024,3.3C10.193,4.47,9.022,6.811,6.683,7.982Z",
    transform: "translate(21.458 26.839)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    d: "M22.983,32.506,8.936.9A7.462,7.462,0,0,0,1.914.9C.743,2.071-.427,5.584.743,6.755Z",
    transform: "translate(2.816 -0.025)",
    fill: "#5d71b6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    d: "M22.983,32.506,8.936.9A7.462,7.462,0,0,0,1.914.9C.743,2.071-.427,5.584.743,6.755Z",
    transform: "translate(2.816 -0.025)",
    fill: "#6576b9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    d: "M22.958,32.506,8.915.9A5.316,5.316,0,0,0,3.063.9C.72,3.244-.451,5.584.72,6.755Z",
    transform: "translate(2.839 -0.025)",
    fill: "#6c7ab9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    "data-name": "Path 1986",
    d: "M22.958,32.238,8.915,1.806a3.316,3.316,0,0,0-5.852,0C.72,2.976-.451,5.316.72,6.487Z",
    transform: "translate(2.839 0.243)",
    fill: "#717fbe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1987",
    "data-name": "Path 1987",
    d: "M22.958,32.239C18.277,21.7,13.594,11.17,8.915,1.806,7.744-.535,5.4-.535,3.063,1.806.72,2.977-.451,5.317.72,6.487Z",
    transform: "translate(2.839 0.242)",
    fill: "#7684c1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1988",
    "data-name": "Path 1988",
    d: "M22.539,30.265C17.857,20.9,13.176,10.367,8.493,1,7.322-.168,4.981-.168,2.641,1A8.877,8.877,0,0,0,.3,5.684Z",
    transform: "translate(3.259 1.045)",
    fill: "#7d8ac2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1989",
    "data-name": "Path 1989",
    d: "M21.889,30.265,7.843,1A3.56,3.56,0,0,0,3.16,1C.82,2.171-.35,4.515.82,5.684Z",
    transform: "translate(3.91 1.045)",
    fill: "#848fc7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1990",
    "data-name": "Path 1990",
    d: "M21.915,30.265C17.23,20.9,12.548,10.367,7.866,1,6.7-.168,4.354-.168,2.014,1h0C.843,2.171-.327,4.515.843,5.684Z",
    transform: "translate(3.887 1.045)",
    fill: "#8a95ca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1991",
    "data-name": "Path 1991",
    d: "M20.741,30.265,6.7,1A3.56,3.56,0,0,0,2.014,1C.843,2.171-.327,4.515.843,5.684Z",
    transform: "translate(3.887 1.045)",
    fill: "#9099cd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1992",
    "data-name": "Path 1992",
    d: "M20.741,30.265,6.7,1A3.56,3.56,0,0,0,2.014,1C.843,2.171-.327,4.515.843,5.684,7.866,13.879,14.89,22.072,20.741,30.265Z",
    transform: "translate(3.887 1.045)",
    fill: "#99a0d1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1993",
    "data-name": "Path 1993",
    d: "M20.3,30.265,6.252,1A3.56,3.56,0,0,0,1.569,1C.4,2.171.4,4.515.4,5.684Z",
    transform: "translate(4.33 1.045)",
    fill: "#a2a8d4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1994",
    "data-name": "Path 1994",
    d: "M20.3,29.094,6.252,1A2.194,2.194,0,0,0,2.74,1,8.877,8.877,0,0,0,.4,5.684Z",
    transform: "translate(4.33 1.045)",
    fill: "#a6aed8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1995",
    "data-name": "Path 1995",
    d: "M19.663,28.024,5.618,1.1a2.194,2.194,0,0,0-3.512,0A2.243,2.243,0,0,0,.935,4.615Z",
    transform: "translate(4.964 2.116)",
    fill: "#afb6dc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1996",
    "data-name": "Path 1996",
    d: "M19.671,28.024,5.626,1.1a2.194,2.194,0,0,0-3.512,0C.943,1.1-.227,3.444.943,3.444Z",
    transform: "translate(4.956 2.116)",
    fill: "#b6bbdf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1997",
    "data-name": "Path 1997",
    d: "M19.671,28.024C14.99,18.66,10.307,9.3,5.626,1.1a2.194,2.194,0,0,0-3.512,0C.943,2.271-.227,3.444.943,3.444Z",
    transform: "translate(4.956 2.116)",
    fill: "#bdc3e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1998",
    "data-name": "Path 1998",
    d: "M19.225,28.024C14.546,18.66,9.864,9.3,5.183,1.1,4.012-.068,2.841-.068,2.841,1.1.5,2.271.5,3.444.5,3.444Z",
    transform: "translate(5.401 2.116)",
    fill: "#c7cbe7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M18.057,26.853,5.183,1.1C4.012-.068,2.841-.068,2.841,1.1.5,2.271.5,3.444.5,3.444Z",
    transform: "translate(5.401 2.116)",
    fill: "#d1d2ea",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M18.057,26.05,4.012.3H1.671C.5.3.5,2.641.5,2.641Z",
    transform: "translate(5.401 2.919)",
    fill: "#d9daee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2001",
    "data-name": "Path 2001",
    d: "M18.057,26.05,4.012.3H1.671C.5.3.5,1.471.5,2.641Z",
    transform: "translate(5.401 2.919)",
    fill: "#e0e0f1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2002",
    "data-name": "Path 2002",
    d: "M17.462,26.05,3.416.3H1.076c-1.171,0,0,2.341,0,2.341Z",
    transform: "translate(5.995 2.919)",
    fill: "#e9ebf6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2003",
    "data-name": "Path 2003",
    d: "M17.462,24.979,3.416.4H1.076c-1.171,0,0,1.171,0,1.171C6.928,9.764,11.611,16.786,17.462,24.979Z",
    transform: "translate(5.995 3.99)",
    fill: "#f1f2f9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2004",
    "data-name": "Path 2004",
    d: "M16.986,24.979,2.941.4H1.771L.6,1.571Z",
    transform: "translate(6.47 3.99)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogoAccretech);
export default __webpack_public_path__ + "static/media/ic_logo_accretech.a7f6a93fad88a53c1b51e06aee71bcc2.svg";
export { ForwardRef as ReactComponent };